require('./contractView.scss');
require('./contractViewStep1.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle, hasTranslation } = require('core/i18n').i18n;
const Immutable = require('immutable');
const PureRenderMixin = require('react-addons-pure-render-mixin');
import getLimitAccountActions from 'actions/getLimitAccount';
import getMainAccountActions from 'actions/getMainAccount';
import hireDepositExpired from 'actions/hireDepositExpired';
import * as officePrintedDocumentActions from 'actions/officePrintedDocument';
import okApiDocuments from 'actions/okApiDocuments';

// @constants
const {
  CONTRACT_INDEX_PAYROLL_ACCOUNT,
  CONTRACT_INDEX_UPGRADE_TO_PAYROLL_ACCOUNT,
  DEFAULT_COUNTRY,
  JUNIOR_ACCOUNT_HIRING_INITIATION_POINT,
  CONTRACT_INDEX_DEPOSIT_PAYROLL,
  BONIFIED_WITHOUT_NEW_MONEY,
} = require('constants/index');
const {
  DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT,
  FIOC_HIDING_ACCOUNTS_ENABLED,
  JOIN_HOLDERS,
  PIN_ACCOUNT,
  PIN_ACCOUNT_COUNTRIES_NOT_ALLOWED,
  WEB_INACTIVE_ACCOUNT_ENABLED,
  FIOC_UPDATE_ACCOUNT_HIRING,
  DNI_UPDATE_ACCOUNT_HIRING,
} = require('constants/flagBasedFeatures.js');
const {
  BUTTON_CLICK,
  CANCEL_ACTION_EVENT,
  CONTRACT_BUTTON,
  LINK_CLICK_ACTION_EVENT,
  NEXT_ACTION_EVENT,
  PREVIOUS_ACTION_EVENT,
  OPT_ACTION_EVENT,
  DEPOSIT_TEXTBOX
} = require('constants/tagging');

// @ utilities
const { getLastNChars } = require('utilities/stringHelper');
const { ownerFromAccount } = require('utilities/contactCenter/cardHireHelper');
const { formatIbanString } = require('commonsUtilities/stringHelper');
const { findElementbyId } = require('./utilities/contractStateHelper');
const {
  PROC_CHECKING_ACCOUNT,
  PROC_GDPR_CONSENTS_CONTRACTS,
  PROC_PAYROLL_ACCOUNT,
  recordLink,
  recordPath,
  PROC_END,
  recordLinkV2
} = require('utilities/tagging');
//@utils
const {
  CONTRATOS_DETAIL_PROCESS,
  CONVERT_TO_OPEN_PAYROLL_ACCOUNT_PASO_PROCESS,
  CONVERT_TO_OPEN_PAYROLL_ACCOUNT_TIPO_PROCESS,
  PAGE_GENERIC,
} = require('constants/tagging');

// @ helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const UrlHelper = require('utilities/urlHelper');
const { getDepositProduct, getMainDepositCategory } = require('utilities/taggingDeposits');
const { getFiocInformation } = require('routes/fiocView/utilities/fiocHelper');

// @ actions
const contractsActions = require('actions/contracts');
const hireJuniorAccountActions = require('actions/hireJuniorAccount');
const hireEAccountLoanActions = require('actions/hireEAccountLoan');
const profile = require('actions/profile');
const hireDepositThirteenMonths = require('actions/hireDepositThirteenMonths');
const hireMainDepositNoNewMoney = require('actions/hireDepositNoNewMoney');
const hireNewMoneyDeposits = require('actions/hireNewMoneyDeposits');
const hireNoNewMoneyDeposits = require('actions/hireNoNewMoneyDeposits');
const hireDepositRenewal = require('actions/hireDepositRenewal');
const hireDepositTransfer = require('actions/hireDepositTransfer');
const hireDepositEighteenMonths = require('actions/hireDepositEighteenMonths');
const fiocFormStatusActions = require('actions/fiocFormStatus');
const preContractualMailActions = require('actions/preContractualMailInfo');
const pdfActions = require('actions/mergePreContractualsPDF');
const preContractualInfo = require('actions/preContractualInfo');
const hiringProductInformation = require('actions/hiringProductInformation');
const hireCardPinSetActions = require('actions/hireCardPinSet');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const blockedAccountsAction = require('actions/blockedAccounts');
const precontractualDocumentMailAction = require('actions/precontractualDocumentsMailer');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');
const hiringProductBannersActions = require('actions/hiringProductBanners');
const contractualPollingActions = require('actions/contractualPolling');
const preContractualPollingActions = require('actions/preContractualPolling');
const termsAndCondsLegalWindowActions = require('actions/termsAndCondsLegalWindow');
const getMainDepositsActions = require('actions/getMainDeposits');
const myProfileUploadDocumentationAction = require('actions/myProfileUploadDocumentation');
const fiocDocumentation = require('actions/fiocDocumentation');

// @components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const AccountBlockedErrorModal = require('components/accounts/accountBlockedErrorModal/accountBlockedErrorModal');
const ContractErrorModal = require('./components/ContractErrorModal/contractErrorModal');
const Step1OutsideFooter = require('./components/Step1OutsideFooter/Step1OutsideFooter');
const Step1OutsideSavingsFooter = require('./components/Step1OutsideSavingsFooter/Step1OutsideSavingsFooter');
import FiocUpdateModal from './components/FiocUpdateModal/FiocUpdateModal'

// @ Components
const PrinterActions = require('actions/contactCenter/printer');
// @hocs
import {
  COUNTRY_CODE_DE,
  COUNTRY_CODE_ES,
  COUNTRY_CODE_FR,
  COUNTRY_CODE_NL,
  COUNTRY_CODE_PT,
} from 'commonsConstants/countryCodes';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { translateText } from "../../../src/routes/myProfileView/myProfileDocumentationView/myProfileUploadDocumentation/getTranslationsMyProfileUploadDocumentation";
import { generateTinAndTae } from './generateTINandTae';

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

// Local components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ContractSummary = require('./components/ContractSummary/contractSummary');
const NewCardDetails = require('./components/newCardDetails/newCardDetails');
const ContractConfirmationStep = require('./components/ContractConfirmationStep/ContractConfirmationStep');
const { ContractComponent } = require('./components/ContractComponent/ContractComponent');

const contractBuilder = require('./libs/contractBuilder');
const contractManager = require('./flows/contractManager');

const availableForAllCountries = [COUNTRY_CODE_ES, COUNTRY_CODE_PT, COUNTRY_CODE_DE, COUNTRY_CODE_FR, COUNTRY_CODE_NL]
const comboTranslationKey = 'comboOption'

let current_contract = {};

const {
  OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
  CHECKING_ACCOUNT_PRODUCT_ALIAS,
} = require('constants/hiringProductInformation');
const {
  HIRE_E_ACCOUNT,
  HIRE_JUNIOR_ACCOUNT,
  DEPOSITS_CODE,
  DEPOSITS_EXCEPTIONS_CODE,
  DEPOSITS_RENEWAL_CODE,
} = require('constants/operationCodesAccounts');

// @constants
import {
  ACCOUNT_TYPE_E_LOAN,
  CHECKING_ACCOUNT,
  DEPOSIT_EIGHTEEN_MONTHS,
  DEPOSIT_THIRTEEN_MONTHS_EXCEPTIONS,
  DEPOSIT_THIRTEEN_MONTHS_RENEWAL,
  ACCOUNT_TYPE_JUNIOR,
  CONTRACT_INDEX_COMBINED_DEPOSIT,
  CONTRACT_INDEX_DEPOSIT_NEW_MONEY,
  CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY,
  CONTRACT_INDEX_DEPOSIT_TRANSFER,
  CONTRACT_INDEX_DEPOSIT_18_MONTHS_RETENTION,
  CONTRACT_INDEX_DEPOSIT_24_MONTHS_RETENTION,
  CONTRACT_INDEX_DEPOSIT_EXPIRATION,
  CONTRACT_INDEX_DEPOSIT_RENEWAL,
} from 'constants/index'
import { DEPOSIT_PRECONTRACTUAL_TYPE } from '../../components/deposits/constants/depositsConstants';

const { WIZARD_FIRST_STEP, REDIRECT_URL } = require('constants/index');

const FLOW_WITH_DIC_ACCOUNTS = [ACCOUNT_TYPE_E_LOAN, CHECKING_ACCOUNT, CONTRACT_INDEX_UPGRADE_TO_PAYROLL_ACCOUNT, CONTRACT_INDEX_PAYROLL_ACCOUNT, ACCOUNT_TYPE_JUNIOR]
const FLOW_WITH_DIC_DEPOSITS = [CONTRACT_INDEX_DEPOSIT_EXPIRATION]

class ContractView extends React.Component {
  constructor(props) {
    super(props);
    const { extraContractData, match: { params }, immFlagBasedFeatures, isNerudaUser, immProfileFields } = props;
    const loadedContract = contractManager.loadContract(params.contractIndex, immFlagBasedFeatures, isNerudaUser, immProfileFields.get('originCountry'));

    current_contract = Immutable.fromJS({
      ...loadedContract,
      ...extraContractData,
    }).toJS();

    this.state = {
      ...current_contract.state,
      nextButtonDisabled: false,
      isTaggingDone: false,
      showAccountLimitModalError: false,
      ...(extraContractData && {
        card_details: [
          ...current_contract.state.card_details,
          ...generateTinAndTae(extraContractData.tin, extraContractData.tae),
        ],
      }),
      loading: false,
    };

    this.isReady = this.isReady.bind(this);
    this.beforeLeaving = this.beforeLeaving.bind(this);
    this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.onHireContract = this.onHireContract.bind(this);
    this.redirectToAccounts = this.redirectToAccounts.bind(this);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    this.showAccountLimitModal = this.showAccountLimitModal.bind(this);
    this.nextStepActions = this.nextStepActions.bind(this)
  }

  UNSAFE_componentWillMount() {
    const {
      contractWizard,
        match: { params: { contractIndex } },
      getProfessionCnaeUncategorized,
      getProfessionCnaeCategory,
      getSectorSubcategories,
      getCountries,
      requestPDFMerge,
      reset,
      resetPrecontractualMail,
      immGlobalVariables,
      immProfileFields,
    } = this.props;
    const { contractualAlias, hasPolling, hasPrecontractualLink } = current_contract;
    const { card_details: cardDetails } = this.state;
    const contracts = immGlobalVariables.getIn(['variables', 'parameters', 'contratos']);


    let inputSafePhone = cardDetails.find(
      component => component.id === 'get_from_profile_PhoneNumber',
    );

    reset();
    resetPrecontractualMail();

    if (inputSafePhone && !inputSafePhone.value) {
      inputSafePhone.value = PersonalDataHelper.getPhoneNumber(immProfileFields);
    }

    if (['checking-account', 'payroll-account'].includes(contractIndex)) {
      if (contractWizard.get('professionCnaeUncategorized').size === 0) {
        getProfessionCnaeUncategorized();
      }
      if (contractWizard.get('professionCnaeCategories').size === 0) {
        getProfessionCnaeCategory();
      }
      if (contractWizard.get('professionSectorSubcategories').size === 0) {
        getSectorSubcategories();
      }
      if (contractWizard.get('countries').size === 0) {
        getCountries();
      }
    }

    const prestacion_servicios_link = contracts && contracts.get('prestacion_servicios_fisicas');
    const contractProvisionList = [{ 'url': prestacion_servicios_link, 'fileName': 'ContractProvision' }];

    if (contractIndex === 'junior-account') {
      contractProvisionList.push({
        fileName: 'DocumentProvisionChildPersonalData',
        url: 'https://www.openbank.es/assets/static/pdf/PieDePagina/Proteccion_Datos_Menor.pdf',
      });
    }

    if ((immProfileFields.get('originCountry') === COUNTRY_CODE_ES) && ['checking-account', CONTRACT_INDEX_PAYROLL_ACCOUNT, CONTRACT_INDEX_UPGRADE_TO_PAYROLL_ACCOUNT].includes(contractIndex)) {
      contractProvisionList.push({
        fileName: 'MiFID',
        url: formatText('preContractDocument-preContractDocument_mifidURL'),
      });
    }

    if (hasPrecontractualLink) {
      const { type, subtype, standard } = current_contract;
      let productsToGetPrecontractuals = [];

      // If the product has an alias, we use it instead of type/subtype/standard
      if (['checking-account'].includes(contractIndex)) {
        const productIdMap = {
          'checking-account': CHECKING_ACCOUNT_PRODUCT_ALIAS,
        };
        productsToGetPrecontractuals.push({ id: productIdMap[contractIndex] });
      } else {
        productsToGetPrecontractuals.push({ type, subtype, standard });
      }

      // If the product has a secondary precontactual document, we add it to the list
      if (['checking-account', CONTRACT_INDEX_PAYROLL_ACCOUNT].includes(contractIndex)) {
        productsToGetPrecontractuals.push({
          id: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS, //CHECKING ACCOUNT AS ASSOCIATED A DEBIT CARD TOO
        });
      }
      requestPDFMerge(contractProvisionList, productsToGetPrecontractuals);
    } else {
      if (!__CONTACT_CENTER__ && !hasPolling && !contractualAlias) {
        requestPDFMerge(contractProvisionList);
      }
    }
  }

  componentDidMount() {
    const {
      contractWizard,
      getBlockedAccounts,
      getFiocFormStatus,
      getLimitAccount,
      getMainDeposits,
      getMainAccount,
      getPreContractualsDocumentURL,
      getOpenYoungProfiles,
      immAccounts,
      immCollectivesNotification,
      immDeposits,
      immFlagBasedFeatures,
      immProfileFields,
      loadState,
      location: { search },
      match: { params: { contractIndex, redirect } },
      requestIntervenersSpecial,
      requestProfile,
      resetPrecontractualDocumentMail,
      setContract,
      setImpositionAmount,
      setInProgress,
      setPayrollAccountPromoCode,
      setRenewalAccountBlocked,
      termsAndCondsLegalWindowSetParams,
      updateCardDetails,
      validateBlockedAccount,
      validatePromotionalCode,
      validateStep,
      history,
      getFiocStatus,
    } = this.props;

    const accountId = new URLSearchParams(search).get('accountId');
    const originCountry = immProfileFields.get('originCountry');

    const hiringData = {
      standard: current_contract.standard,
      subType: current_contract.subtype,
      type: current_contract.type,
    };

    immFlagBasedFeatures.get(DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT) && validateBlockedAccount();
    setContract(contractIndex, current_contract.termsAndCondsKey, hiringData);
    const precontractualAlias = current_contract.preContractualAlias ? current_contract.preContractualAlias : null;
    const contractualAlias = current_contract.contractualAlias ? current_contract.contractualAlias : null;
    termsAndCondsLegalWindowSetParams(precontractualAlias, contractualAlias);
    resetPrecontractualDocumentMail();
    const { card_details: cardDetails } = this.state;
    let initialLoad = Object.assign({ steps: current_contract.steps }, this.state);

    if (current_contract.initState) {
      initialLoad = contractBuilder[current_contract.initState](initialLoad);
    }

    loadState(initialLoad);
    const formTarget = contractWizard.get('form_target');
    const immCardDetails = contractWizard.get('card_details');

    if (contractIndex === CONTRACT_INDEX_PAYROLL_ACCOUNT || contractIndex === CONTRACT_INDEX_UPGRADE_TO_PAYROLL_ACCOUNT) {
      const promoCode = immCollectivesNotification.get('promoCode');
      if (promoCode) {
        setPayrollAccountPromoCode(promoCode);
        validatePromotionalCode(promoCode, true);
      }
    }

    if (contractIndex === ACCOUNT_TYPE_E_LOAN) {
      getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_E_ACCOUNT);
    }
    if (contractIndex === ACCOUNT_TYPE_JUNIOR) {
      getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_JUNIOR_ACCOUNT);
    }
    if ([
      DEPOSIT_EIGHTEEN_MONTHS,
      CONTRACT_INDEX_DEPOSIT_NEW_MONEY,
      CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY,
      CONTRACT_INDEX_DEPOSIT_TRANSFER,
    ].includes(contractIndex)) {
      getBlockedAccounts(immAccounts.get('byId').toList(), DEPOSITS_CODE);
    }

    if ([CONTRACT_INDEX_DEPOSIT_EXPIRATION].includes(contractIndex)) {
      getBlockedAccounts(immAccounts.get('byId').toList(), DEPOSITS_CODE);

      const depositId = contractWizard.get('renewalOrExpiredDepositId');
      const maxAmount = contractWizard.get('maxAmount');
      const deposit = immDeposits.getIn(['byId', depositId]);

      const impositionCurrency = deposit && deposit.getIn(['impositionList', 'byId']).first().get('currency');
      setImpositionAmount({ amount: maxAmount, currency: impositionCurrency });
    }

    if ([CONTRACT_INDEX_DEPOSIT_RENEWAL].includes(contractIndex)) {
      getBlockedAccounts(immAccounts.get('byId').toList(), DEPOSITS_CODE);

      const depositId = contractWizard.get('renewalOrExpiredDepositId');
      const deposit = immDeposits.getIn(['byId', depositId]);

      const renewalAccount = immAccounts.get('byId').filter(account =>
        (account.get('contractNumber') === deposit.getIn(['impositionAssociatedAccount', 'contractNumber']) &&
        account.get('product') === deposit.getIn(['impositionAssociatedAccount', 'product']))).first();

      const hasNotices = renewalAccount.get('indicadorAVISOA');
      const criticalNotice = renewalAccount.get('indicadorINDACCI');

      const impositionAmount = deposit.getIn(['impositionList', 'byId']).first().get('amount');
      const impositionCurrency = deposit.getIn(['impositionList', 'byId']).first().get('currency');

      setImpositionAmount({ amount: impositionAmount, currency: impositionCurrency });
      setRenewalAccountBlocked(hasNotices === 'S' && criticalNotice >= 16);
    }

    if ([DEPOSIT_THIRTEEN_MONTHS_EXCEPTIONS, CONTRACT_INDEX_DEPOSIT_18_MONTHS_RETENTION, CONTRACT_INDEX_DEPOSIT_24_MONTHS_RETENTION].includes(contractIndex)) {
      getBlockedAccounts(immAccounts.get('byId').toList(), DEPOSITS_EXCEPTIONS_CODE);
    }
    if ([DEPOSIT_THIRTEEN_MONTHS_RENEWAL, CONTRACT_INDEX_COMBINED_DEPOSIT].includes(contractIndex)) {
      getBlockedAccounts(immAccounts.get('byId').toList(), DEPOSITS_RENEWAL_CODE);
    }

    if (accountId) {
      const immAccount = immAccounts.getIn(['byId', accountId]);
      const balanceAccount = cardDetails.find(component => component.id === 'balance_account');
      if (balanceAccount) {
        balanceAccount.value = immAccount.getIn(['balances', 'availableBalance', 'amount']);
      }
      const hasAccountPreselected = cardDetails.find(
        detail => detail.id === 'hasAccountPreselected',
      );
      hasAccountPreselected && (hasAccountPreselected.value = true);

      const selectedAccount = cardDetails.find(x => x.id === 'cta_seleccionada');
      selectedAccount.value = accountId;
      selectedAccount.description = `${immAccount.get('alias')} ${getLastNChars(immAccount.get('iban'))}`;

      requestIntervenersSpecial(immAccount);
      updateCardDetails(cardDetails);
    }

    setInProgress();
    requestProfile(history);

    if (formTarget) {
      const formList = immCardDetails.filter(targetValue => targetValue.id === formTarget)[0]
        ?.value;
      if (formList?.length >= 1) {
        formList.forEach(form => {
          this.state.card_details.filter(
            formObject => formObject.id === form,
          )[0].value = [];
        });
      }
    }
    if (redirect === REDIRECT_URL) {
      validateStep(WIZARD_FIRST_STEP);
    }

    if (current_contract.loadDataAction) {
      this.props[current_contract.loadDataAction]();
    }

    if (!__CONTACT_CENTER__ && contractIndex === 'junior-account') {
      getOpenYoungProfiles();
    }


    if ([CONTRACT_INDEX_DEPOSIT_NEW_MONEY].includes(contractIndex)) {
      getMainDeposits('WITH_NEW_MONEY');
    }

    if ([CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY].includes(contractIndex)) {
      getMainDeposits('WITHOUT_NEW_MONEY');
    }

    if ([CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractIndex)) {
      getMainDeposits(BONIFIED_WITHOUT_NEW_MONEY);
    }

    if ([CONTRACT_INDEX_DEPOSIT_RENEWAL, CONTRACT_INDEX_DEPOSIT_EXPIRATION].includes(contractIndex)) {
      getMainDeposits(undefined,contractWizard.get('fromRenewalOrTransferToken'));
    }

    if ([CONTRACT_INDEX_DEPOSIT_TRANSFER].includes(contractIndex)) {
      getMainDeposits(undefined,redirect);
    }

    if (ACCOUNT_TYPE_E_LOAN === contractIndex) {
      getMainAccount(redirect, originCountry)
      !__CONTACT_CENTER__ && getLimitAccount()
    }

    if (this.isCheckingOrPayroll()) {
      getFiocStatus()
    }
  }

  omitFiocStep ({ currentStep, nextStep, fiocStep = 3, changeVisibleStep, fiocFF, fiocRequired = true }) {
    const stepBeforeFioc = fiocStep - 1;
    const stepAfterFioc = fiocStep + 1;

    if (currentStep === stepBeforeFioc && nextStep === fiocStep && (!fiocRequired && fiocFF)) {
      changeVisibleStep(nextStep + 1);
    }

    if (currentStep === stepAfterFioc && nextStep === fiocStep && (!fiocRequired && fiocFF)) {
      changeVisibleStep(nextStep - 1);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      contractWizard: nextContractWizard,
      immPreContractualPolling: immNextPreContractualPolling,
    } = nextProps;
    const {
      contractWizard: currentContractWizard,
      immFlagBasedFeatures,
      immPreContractualPolling,
      match: { params: { contractIndex } },
      pollingPDFMerge,
      preContractualPollingInitialization,
      updateCardDetails,
      updateConditionDocumentConfirmation,
      setDepositPolled,
      setVisibleStep,
      validateStep,
      resetContractualPolling,
      resetPreContractualPolling,
      resetPrecontractualMail,
      getPrecontractualDocumentURLOrID,
      immProfileFields,
      getDepositLegalTextFormatteddValue,
    } = this.props;
    const originCountry = immProfileFields.get('originCountry');
    const currentStep = currentContractWizard.get('visibleStep');
    const nextStep = nextContractWizard.get('visibleStep');
    const step = `step_${nextStep}`;
    const { preContractualAlias } = current_contract;
    const { deposit_product: depositProduct } = this.state;
    const operationProcessId = immNextPreContractualPolling.get('operationProcessId');
    let cardDetails = nextContractWizard.get('card_details');
    const isAllowedFiocUpdateAccountHiring = immFlagBasedFeatures.get(FIOC_UPDATE_ACCOUNT_HIRING);
    if (this.isCheckingOrPayroll()) {
      this.omitFiocStep({
        currentStep,
        nextStep,
        fiocStep: __CONTACT_CENTER__ ? 2 : 3,
        changeVisibleStep: setVisibleStep,
        fiocFF: isAllowedFiocUpdateAccountHiring,
        fiocRequired: currentContractWizard.getIn(['fiocStatus', 'fiocRequested'])
      })
    }

    if (!__CONTACT_CENTER__ && immFlagBasedFeatures.get(JOIN_HOLDERS) && this.isCheckingOrPayroll()) {
      if (currentStep === 4 && nextStep === 5 && this.isCheckingOrPayrollWithoutHolders()) {
        validateStep(5); // With this I jump directly to step 6 skipping a step with an empty state.
      }

      if (currentStep === 6 && nextStep === 5 && this.isCheckingOrPayrollWithoutHolders()) {
        setVisibleStep(nextStep - 1); // With this I jump directly to step 4 skipping a step with an empty state.
      }
    } else {
      if (currentStep === 3 && nextStep === 4 && this.isCheckingOrPayrollWithoutHolders()) {
        if (this.isPayroll() || !this.isPayroll() && originCountry === COUNTRY_CODE_ES) {
          validateStep(4); // With this I jump directly to step 5 skipping a step with an empty state.
        }
      }

      if (currentStep === 5 && nextStep === 4 && this.isCheckingOrPayrollWithoutHolders()) {
        if (this.isPayroll() || !this.isPayroll() && originCountry === COUNTRY_CODE_ES) {
          setVisibleStep(nextStep - 1); // With this I jump directly to step 3 skipping a step with an empty state.
        }
      }
    }

    if (cardDetails) { // checking cardDetails if is not null because findElementbyId throws an error in line 3 using find method.
      if (immFlagBasedFeatures.get(FIOC_HIDING_ACCOUNTS_ENABLED)) {
        const ocupation = findElementbyId(cardDetails, 'fioc_ocupation');
        const showFiocAlertPopUp = findElementbyId(cardDetails, 'show_fioc_alert');
        let mustReturnToStep1WithFiocHidden;
        let setFiocAlertPopUp;
        let newCardDetails;

        const currentShowFioc = currentContractWizard.getIn(['fiocStatus', 'showFioc'])
        const currentIsFiocStatusFetched = currentContractWizard.getIn(['fiocStatus', 'isFetched'])

        if (!__CONTACT_CENTER__ && immFlagBasedFeatures.get(JOIN_HOLDERS) && this.isCheckingOrPayroll()) {
          mustReturnToStep1WithFiocHidden = currentIsFiocStatusFetched && !currentShowFioc && currentStep === 3 && nextStep === 2;
          setFiocAlertPopUp = currentIsFiocStatusFetched && !currentShowFioc && ocupation !== null && !showFiocAlertPopUp && currentStep === 3 && nextStep === 3;
        } else {
          mustReturnToStep1WithFiocHidden = currentIsFiocStatusFetched && !currentShowFioc && currentStep === 2 && nextStep === 1;
          setFiocAlertPopUp = currentIsFiocStatusFetched && !currentShowFioc && ocupation !== null && !showFiocAlertPopUp && currentStep === 2 && nextStep === 2;
        }

        if (currentShowFioc !== nextContractWizard.getIn(['fiocStatus', 'showFioc'])) {
          cardDetails = cardDetails.update(
            cardDetails.findIndex(component => component.get('id') === 'show_fioc'),
            component => component.set('value', nextContractWizard.getIn(['fiocStatus', 'showFioc'])),
          );
          updateCardDetails(cardDetails);
        } else if (nextContractWizard.getIn(['fiocStatus', 'error', 'errorObject']) !== currentContractWizard.getIn(['fiocStatus', 'error', 'errorObject'])) {
          cardDetails = cardDetails.update(
            cardDetails.findIndex(component => component.get('id') === 'show_fioc'),
            component => component.set('value', true),
          );
          updateCardDetails(cardDetails);
        } else if (mustReturnToStep1WithFiocHidden) {
          const cardDetailsFiocIndex = cardDetails.findIndex(component => component.get('id') === 'show_fioc');
          const isFiocOpen = cardDetails.getIn([cardDetailsFiocIndex, 'value']);

          if (ocupation === null && isFiocOpen) {
            newCardDetails = cardDetails.update(
              cardDetails.findIndex(component => component.get('id') === 'show_fioc'),
              component => component.set('value', false),
            );
            newCardDetails = newCardDetails.update(
              cardDetails.findIndex(component => component.get('id') === 'fioc_ocupation'),
              component => component.set('isErrorVisible', false),
            );
            updateCardDetails(newCardDetails);
          }
        } else if (setFiocAlertPopUp) {
          newCardDetails = cardDetails.update(
            cardDetails.findIndex(component => component.get('id') === 'show_fioc_alert'),
            component => component.set('value', true),
          );
          updateCardDetails(newCardDetails);
        }
      } else if (findElementbyId(cardDetails, 'show_fioc') === false) {
        cardDetails = cardDetails.update(
          cardDetails.findIndex(component => component.get('id') === 'show_fioc'),
          component => component.set('value', true),
        );
        updateCardDetails(cardDetails);
      }

    }

    this.setState({
      card_details: cardDetails && cardDetails.toJS(),
    });

    if (contractIndex === 'junior-account' &&
      !currentContractWizard.getIn(['openYoungProfiles', 'fetched']) && nextContractWizard.getIn(['openYoungProfiles', 'fetched'])) {
      contractBuilder.juniorAccount_setCardOwners(nextContractWizard.getIn(['openYoungProfiles', 'list']).toJS());
    }
    const mainDepositsSuccess = currentContractWizard.getIn(['mainDeposits', 'success']);
    const nextMainDepositsSuccess = nextContractWizard.getIn(['mainDeposits', 'success']);

    if ([CONTRACT_INDEX_DEPOSIT_RENEWAL, CONTRACT_INDEX_DEPOSIT_EXPIRATION, CONTRACT_INDEX_DEPOSIT_TRANSFER].includes(contractIndex) &&
        !mainDepositsSuccess &&
        nextMainDepositsSuccess
      ) {
        getPrecontractualDocumentURLOrID({
          payload: {
            metadata: {
              depositIdentify: nextContractWizard.getIn(['mainDeposits', 'data', 'depositIdentify']),
              language: originCountry,
              termPeriod: formatText('contractsView-months'),
              productType: formatText(`${nextContractWizard.getIn(['mainDeposits', 'data', 'context'])}-${nextContractWizard.getIn(['mainDeposits', 'data', 'name'])}`)
            },
            precontractualType: DEPOSIT_PRECONTRACTUAL_TYPE[contractIndex]
          }
        })
    }

    /* Specific validations for step loading time. Put in the flow file something like this:
    state: {
        onStepLoadValidation: {
            [`step_${WIZARD_SECOND_STEP}`]: {
                actionName: 'isUserAbleToHireDepositThirteenMonths', // action to execute
            }
        },
        ...
    }
    */
    if (
      nextContractWizard.getIn(['onStepLoadValidation', step]) &&
      !nextContractWizard.get('dataIsFetching')
    ) {
      this.props[nextContractWizard.getIn(['onStepLoadValidation', step, 'actionName'])]();
    }
    if ([CONTRACT_INDEX_DEPOSIT_NEW_MONEY, CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY, CONTRACT_INDEX_DEPOSIT_TRANSFER, CONTRACT_INDEX_DEPOSIT_RENEWAL, CONTRACT_INDEX_DEPOSIT_EXPIRATION, CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractIndex)) {
      const { context, preContractualAlias, name } = depositProduct;
      const depositPolled = currentContractWizard.get('depositPolled');
      if (currentStep === 2 && nextStep === 3 && !!preContractualAlias && !immNextPreContractualPolling.getIn(['init', 'hasBeenFetched'])) {
        if (contractIndex === CONTRACT_INDEX_DEPOSIT_RENEWAL) {
          preContractualPollingInitialization(preContractualAlias, currentContractWizard.get('precontractualDocumentId'));
        } else if (contractIndex === CONTRACT_INDEX_DEPOSIT_TRANSFER) {
          preContractualPollingInitialization(preContractualAlias, currentContractWizard.get('precontractualDocumentId'), currentContractWizard.get('precontractualDocumentUrl'));
        } else if (__CONTACT_CENTER__ && contractIndex === CONTRACT_INDEX_DEPOSIT_EXPIRATION) {
          preContractualPollingInitialization(current_contract.preContractualAlias, currentContractWizard.get('precontractualDocumentId'), currentContractWizard.get('precontractualDocumentUrl'));
        } else if (!FLOW_WITH_DIC_DEPOSITS.includes(contractIndex)) {
          preContractualPollingInitialization(preContractualAlias);
        }
        setDepositPolled(currentContractWizard.getIn(['deposit_product', 'name']));
      }

      if (currentStep === 3 && __CONTACT_CENTER__) {
        const isClassicDeposit = ![CONTRACT_INDEX_DEPOSIT_TRANSFER, CONTRACT_INDEX_DEPOSIT_EXPIRATION, CONTRACT_INDEX_DEPOSIT_RENEWAL].includes(contractIndex)

        const depositLegalTextRequestData = nextContractWizard.getIn(['depositLegalText', 'requestData']).toJS();
        const nextAmount = findElementbyId(cardDetails, 'monto_traspasar');
        const depositIdentify = isClassicDeposit
          ? nextContractWizard.getIn(['deposit_product', 'depositIdentify'])
          : nextContractWizard.getIn(['mainDeposits', 'data', 'depositIdentify'])

        const depositId = nextContractWizard.get('renewalOrExpiredDepositId');

        if (depositIdentify !== depositLegalTextRequestData.depositIdentify || nextAmount !== depositLegalTextRequestData.amount) {
          getDepositLegalTextFormatteddValue({
            depositIdentify,
            amount: nextAmount,
            depositId
          })
        }
      }

      if (currentStep === 2 && nextStep === 3 && !!preContractualAlias && depositPolled && depositPolled !== currentContractWizard.getIn(['deposit_product', 'name'])) {
        resetPreContractualPolling();
        resetContractualPolling();
        resetPrecontractualMail();
        updateConditionDocumentConfirmation(false);
        if (contractIndex === CONTRACT_INDEX_DEPOSIT_TRANSFER) {
          preContractualPollingInitialization(preContractualAlias, currentContractWizard.get('precontractualDocumentUrl'));
        }
        else if (contractIndex === CONTRACT_INDEX_DEPOSIT_RENEWAL) {
          preContractualPollingInitialization(preContractualAlias, currentContractWizard.get('precontractualDocumentId'));
        } else if (!FLOW_WITH_DIC_DEPOSITS.includes(contractIndex)) {
          preContractualPollingInitialization(preContractualAlias);
        }
        setDepositPolled(currentContractWizard.getIn(['deposit_product', 'name']));
      }

      if ((currentStep === 3 && !!preContractualAlias && !!operationProcessId && !immPreContractualPolling.getIn(['documents', 'success']) && immNextPreContractualPolling.getIn(['documents', 'success'])) ||
        (currentStep === 4 && nextStep === 3 && !!preContractualAlias && !!operationProcessId)
      ) {
        pollingPDFMerge(operationProcessId);
      }

      if (currentStep === 2 && nextStep === 3 && !!preContractualAlias && !!operationProcessId && immPreContractualPolling.getIn(['documents', 'success']) && (!depositPolled || depositPolled === currentContractWizard.getIn(['deposit_product', 'name']))) {
        pollingPDFMerge(operationProcessId);
      }
    } else {
      if (!current_contract.hasDocumentsModal && ((currentStep === 3 && nextStep === 2 && !!preContractualAlias && !!operationProcessId) ||
        (currentStep === 1 && nextStep === 2 && !!preContractualAlias && !!operationProcessId && immNextPreContractualPolling.getIn(['documents', 'success'])) ||
        (currentStep === 2 && !!preContractualAlias && !!operationProcessId && !immPreContractualPolling.getIn(['documents', 'success']) && immNextPreContractualPolling.getIn(['documents', 'success'])))) {
          pollingPDFMerge(operationProcessId);
      }

      if (ACCOUNT_TYPE_E_LOAN === contractIndex && (__CONTACT_CENTER__ && currentStep === 1)) {
        const precontractualDocumentId = nextContractWizard.get('precontractualDocumentId')
        const precontractualDocumentUrl = nextContractWizard.get('precontractualDocumentUrl')
        const precontractualDicUrl = nextContractWizard.getIn(['mainAccount', 'data', 'accountConfig', 'precontractualDicUrl'])

        if (!immNextPreContractualPolling.getIn(['init', 'hasBeenFetched']) && (precontractualDocumentId || precontractualDocumentUrl)) {
          preContractualPollingInitialization(current_contract.preContractualAlias, precontractualDocumentId, precontractualDocumentUrl, null, {
            precontractualDicUrl
          });
        }
      }

      if (!__CONTACT_CENTER__ && !FLOW_WITH_DIC_ACCOUNTS.includes(contractIndex) && !!current_contract.preContractualAlias && !immNextPreContractualPolling.getIn(['init', 'hasBeenFetched'])) {
        preContractualPollingInitialization(current_contract.preContractualAlias);
      }

      if (__CONTACT_CENTER__ && ACCOUNT_TYPE_E_LOAN !== contractIndex && !!current_contract.preContractualAlias && !immNextPreContractualPolling.getIn(['init', 'hasBeenFetched'])) {
        preContractualPollingInitialization(current_contract.preContractualAlias);
      }
    }
  }

  async getFiocInformationForm() {
    this.setState({ loading: true });

    let cardDetailsCopy = JSON.parse(JSON.stringify(this.state.card_details));
    const findCardDetailById = id => cardDetailsCopy.find(cardDetailId => cardDetailId.id === id);

    try {
        const fiocData = await getFiocInformation();

        if (fiocData?.workFor === '02') {
            findCardDetailById('fioc_ocupation').value = 1;
        }

        const parsedFiocFields = this.props.parseFiocData(fiocData);

        parsedFiocFields.forEach(({id, value}) => {
            if (findCardDetailById(id)) {
                findCardDetailById(id).value = value;

                if (id === 'income_origin_tooltip' && value === true) {
                    findCardDetailById(id).disabled = value;
                }
            }
        });

        this.props.updateCardDetails(cardDetailsCopy);
    } catch (error) {
    } finally {
        this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    const { immHiringProductBanners, showAccountBlockedErrorModal, match: { params: { contractIndex } }, contractWizard: currentContractWizard, } = this.props;
    const isError = immHiringProductBanners.get('isAccountBlockedValidationError');
    const isSuccess = immHiringProductBanners.get('isAccountBlockedValidationSuccess');
    const isFetching = immHiringProductBanners.get('isAccountBlockedValidationFetching');
    const isCnaeFetching = currentContractWizard.get('professionCnaeUncategorizedIsFetching');

    const currentStep = currentContractWizard.get('visibleStep');
    const prevStep = prevProps.contractWizard.get('visibleStep');
    const mainDepositsSuccess = currentContractWizard.getIn(['mainDeposits', 'success']);
    const prevMainDepositsSuccess = prevProps.contractWizard.getIn(['mainDeposits', 'success']);

    if (prevProps.immHiringProductBanners.get('isAccountBlockedValidationError') !== isError && isError) {
      if (!isSuccess && !isFetching) {
        showAccountBlockedErrorModal(true);
      }
    }

    if ((contractIndex === CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY && currentStep === 2 && prevStep !== 2 && mainDepositsSuccess) || (contractIndex === CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY && currentStep === 2 && !prevMainDepositsSuccess && mainDepositsSuccess)) {
      contractBuilder.checkingAccount_handleStep2LoadTagging(currentContractWizard);
    }

    if (
      !isCnaeFetching &&
      prevProps.contractWizard.get('professionCnaeUncategorizedIsFetching') !== isCnaeFetching
    ) {
      this.getFiocInformationForm();
    }
  }

  componentWillUnmount() {
    this.props.hireCardImageSelectorReset();
    this.props.pinSetReset();
    this.props.resetBlockedAccounts();
    this.props.resetJuniorAccountHiringInitiationPoint();
    this.props.resetPreContractualInfo();
    this.props.resetProductInfo();
    this.props.resetTermsAndCondsText();
    this.props.resetTermsAndCondsLegalWindow();
    this.props.fiocFormStatusReset();
    this.props.reset();
    this.props.resetPreContractualPolling();
    this.props.resetContractualPolling();
    this.props.resetPDFMerge();
    this.props.resetPdfToPrint();
    this.props.depositLegalTextReset();
  }

  isPayroll() {
    const { match: { params: { contractIndex } } } = this.props;
    return 'payroll-account' === contractIndex;
  }

  isCheckingOrPayroll() {
    const { match: { params: { contractIndex } } } = this.props;
    return ['checking-account', 'payroll-account'].includes(contractIndex);
  }

  isCheckingOrPayrollWithoutHolders() {
    let returnValue = false;
    if (this.isCheckingOrPayroll()) {
      const { contractWizard } = this.props;
      const cardDetails = contractWizard.get('card_details');
      const hasHolders = findElementbyId(cardDetails, 'holders').get(0);
      returnValue = !hasHolders;
    }
    return returnValue;
  }

  onHireContract() {
    const {
      contractWizard,
      hireEAccountLoan,
      hireContractNewAccount,
      hireDepositThirteenMonths,
      hireDepositEighteenMonths,
      hireNoNewMoneyDeposits,
      hireJuniorAccount,
      immAccounts,
      immDeposits,
      immProfileFields,
      signaturePattern,
      immConsentsGdpr,
      upgradeToPayrollAccount,
      hireNewMoneyDepositMonths,
      hireMainDepositNoNewMoney,
      hireDepositRenewal,
      hireDepositTransfer,
      hireDepositExpired,
      immFlagBasedFeatures,
    } = this.props;
    const card_details = contractWizard.get('card_details');
    const cta_seleccionada = card_details.find(x => x.get('id') === 'cta_seleccionada');
    const accountId = cta_seleccionada ? cta_seleccionada.get('value') : null;
    const immAccount = accountId ? immAccounts.get('byId').get(accountId) : null;
    const confirmationCheckboxesAreValid = contractWizard.getIn([
      'confirmationCheckboxes',
      'areValid',
    ]);
    const isFetchingConfigSuccess = current_contract.code_op
      ? signaturePattern.get('isFetchingConfigSuccess')
      : true; // is usefull when you don't need code_op and code_op is set in null
    let promotionalCodeChecked =
      !contractWizard.get('promotionalCode') ||
      contractWizard.get('promotionalCodeAcceptanceCheckboxChecked');
    let params;
    let results = '';

    if (confirmationCheckboxesAreValid && promotionalCodeChecked && isFetchingConfigSuccess) {
      switch (contractWizard.get('name_contract')) {
        case 'e-account-loan':
          hireEAccountLoan();
          break;

        case 'junior-account':
          hireJuniorAccount();
          break;

        case 'checking-account':
        case 'payroll-account':
          const isAllowedFeatureFlags = immFlagBasedFeatures.get(DNI_UPDATE_ACCOUNT_HIRING) && immFlagBasedFeatures.get(FIOC_UPDATE_ACCOUNT_HIRING)
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immProfileFields,
            isAllowedFeatureFlags
          );

          hireContractNewAccount(params, () => {
            const { successStep } = current_contract;

            let nombre = immProfileFields.get('nombreCliente');
            let apellidoUno = immProfileFields.get('apellidoUno').get('apellido');
            let apellidoDos = immProfileFields.get('apellidoDos').get('apellido');

            successStep.details[0][0].details[1].interveners.push({
              name: `${apellidoUno} ${apellidoDos} ${nombre}`,
              type: 'contractSummary-intevenierTitular',
            });

            const holders = card_details
              .find(x => x.get('id') === 'holders')
              .get('value');

            if (holders.get(0)) {
              let type = 'intevenier';
              holders.get(1).map(holder => {
                let nombre = holder.get('firstName');
                let apellidoUno = holder.get('lastName');
                let apellidoDos = holder.get('secondlastName');

                switch (holder.get('accountRelation')) {
                  case 1: // titular
                    type = 'intevenier';
                    break;
                  case 2: // Apoderado
                    type = 'intevenierAttorney';
                    break;
                  case 3: // Autorizado
                    type = 'intevenierAuthorized';
                    break;
                }

                successStep.details[0][0].details[1].interveners.push({
                  name: `${apellidoUno} ${apellidoDos} ${nombre}`,
                  type: `contractSummary-${type}`,
                });
              });
            }
          });
          break;

        case 'deposit-thirteen-months':
        case 'deposit-thirteen-months-due-dates':
        case 'deposit-thirteen-months-excepciones':
        case 'deposit-thirteen-months-leak-retention':
        case 'deposit-thirteen-months-linked-maturities':
        case 'deposit-thirteen-months-renovacion-excepciones':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireDepositThirteenMonths(params);
          break;

        case 'deposit-eighteen-months-retention':
        case 'combined-deposit':
        case 'deposit-twentyfour-months-retention':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireNoNewMoneyDeposits(params);
          break;

        case 'deposit-eighteen-months':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireDepositEighteenMonths(params);
          break;

        case 'upgrade-to-payroll-account':
          params = contractBuilder[current_contract.hireParamsFn](
            immAccount,
            contractWizard,
          );
          upgradeToPayrollAccount(params);
          break;

        case 'deposittransfer':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireDepositTransfer(params);
          break;

        case 'depositrenewal':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
            immDeposits
          );
          hireDepositRenewal(params);
          break;

        case 'depositexpired':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
            immDeposits
          );
          hireDepositExpired(params);
          break;

        case 'depositnm':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireNewMoneyDepositMonths(params);
          break;
        case 'deposit':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireMainDepositNoNewMoney(params);
          break;
        case 'depositpayroll':
          params = contractBuilder[current_contract.hireParamsFn](
            contractWizard,
            immAccount,
          );
          hireMainDepositNoNewMoney(params);
          break;
      }
    }

    immConsentsGdpr.get('consents').forEach(immConsent => {
      const id = immConsent.getIn(['consentCell', 'id']);
      const status = immConsent.get('status');
      results += `${id}:${status}|`;
    });
    results = results.substring(0, results.length - 1);
    recordLink(PROC_GDPR_CONSENTS_CONTRACTS, PROC_END, results);
  }

  setComponentState(stateObject) {
    this.setState(stateObject);
  }

  beforeLeaving() {
    const { reset, resetPrecontractualMail } = this.props;
    reset();
    resetPrecontractualMail();
  }


  buildConfirmationStep(initialStepHasLegalInformation) {
    const {
      cancelPromotionalCode,
      contractWizard,
      closeModal,
      contractualPollingInitialization,
      fetchPdfToPrint,
      getHiringDocuments,
      getDocumentsOkApiById,
      resetPDFMerge,
      immAccounts,
      immCommercialAds,
      immContractualPolling,
      immDeposits,
      immMergePDFDocuments,
      immOfficePrintedDocument,
      immProfileFields,
      location: { search },
      onDownloadDocument,
      onPrintDocument,
      pollingPDFMerge,
      promotionalCodeAcceptanceChecboxChecked,
      promotionalCodeSetDirty,
      resetDocumentsAndAgreeCheckBox,
      sendPrecontractualDocumentMail,
      toggleAgree,
      updateConfirmationCheckboxes,
      validatePromotionalCode,
      setTermsAndCondsText,
      getPrecontractualDocumentURLOrID,
      match
    } = this.props;
    const {
      alertMessage,
      code_op: signaturePatternCode,
      confirmationLabel,
      gdprPlacementId,
      multiOTPMessageCode,
      promo_code: promoCodeEnabled,
      operativeName,
      SignParamsFn,
      warningContractMessage,
      preContractualMail,
      warningContractMessageDynamic,
      sendPreContractualMail,
      requestProfile,
      hasContractPdfViewer,
      getCustomPrintDocument,
      bodyClass,
      printDocumentTranslations,
      noWarningMessage,
      customTagging,
    } = current_contract;
    const accountId = new URLSearchParams(search).get('accountId');
    const immFinalButton = 'contractsView-contratar';
    const params = contractBuilder[SignParamsFn](contractWizard, immAccounts);
    let warningMessage = warningContractMessage || 'contractsView-defaultWarningMessage';
    if (warningContractMessageDynamic) {
      warningMessage = contractBuilder[warningContractMessageDynamic](contractWizard);
    }
    const customCategoryEvent = customTagging ? contractBuilder[customTagging](contractWizard).eventCategory : undefined;

    const confirmationType = contractWizard.get('name_contract') === 'depositrenewal' ? 3 : undefined;
    const confirmationCheckboxes = contractWizard.get('confirmationCheckboxes');
    const confirmationMessage = contractWizard.get('confirmationMessage');
    const operativeNameText = operativeName ? operativeName : 'operatives-depositHire_default'; //Need to change this default value to something more appropriate
    const isLoading = contractWizard.get('isLoading');
    const { confirmationExtraComponents } = current_contract;
    const finalButtonDisabled = !contractWizard.getIn(['confirmationCheckboxes', 'areValid']);

    const customPrintDocument = getCustomPrintDocument ? contractBuilder[getCustomPrintDocument](contractWizard, immProfileFields, immAccounts) : undefined;
    const handleSMSClick = contractWizard.get('name_contract') === 'depositrenewal' ? () => {recordLink(customCategoryEvent ? customCategoryEvent : window.utag_last_name, OPT_ACTION_EVENT, DEPOSIT_TEXTBOX)} : undefined;
    const handleDocument = {
      getHiringDocuments,
      toggleAgree,
      onDownloadDocument,
      onPrintDocument,
      resetDocumentsAndAgreeCheckBox,
    };
    const extraComponents =
      confirmationExtraComponents &&
      confirmationExtraComponents.map((component, index) => {

        return (
            <ContractComponent
                key={index}
                preContractualMail={preContractualMail}
                accountId={accountId}
                sendPreContractualMail={sendPreContractualMail}
                component={component}
                localState={this.state}
                contractWizard={contractWizard}
                updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                current_contract={current_contract}
                requestProfile={requestProfile}
                immProfileFields={immProfileFields}
                immCommercialAds={immCommercialAds}
                immDeposits={immDeposits}
                immAccounts={immAccounts}
                nextStep={this.nextStep}
                closeModal={closeModal}
            />
        );
      });

    return (
        <WizardStep
            key="last"
            addLoadingBehaviour={!__CONTACT_CENTER__}
            position="last"
            cancelButton={true}
            immFinalButton={immFinalButton}
            finalButtonDisabled={finalButtonDisabled}
            signaturePatternCode={signaturePatternCode}
            isLoading={isLoading}
      >
            <ContractConfirmationStep
                alertMessage={alertMessage}
                confirmationCheckboxes={confirmationCheckboxes}
                confirmationMessage={confirmationMessage}
                contractualPollingInitialization={contractualPollingInitialization}
                contractWizard={contractWizard}
                customCategoryEvent={customCategoryEvent}
                current_contract={current_contract}
                getDocumentsOkApiById={getDocumentsOkApiById}
                showDepositAlertMessage={contractBuilder.depositnm_show45DaysWarning}
                pollingPDFMerge={pollingPDFMerge}
                signaturePatternCode={signaturePatternCode}
                handleDocument={handleDocument}
                handleSMSClick={handleSMSClick}
                hasContractPdfViewer={hasContractPdfViewer}
                immMergePDFDocuments={immMergePDFDocuments}
                immAccounts={immAccounts}
                immDeposits={immDeposits}
                immOfficePrintedDocument={immOfficePrintedDocument}
                immProfileFields={immProfileFields}
                match={match}
                params={params}
                noWarningMessage={noWarningMessage ? noWarningMessage : undefined}
                updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                fetchPdfToPrint={current_contract.needsPdfUrlFetching && fetchPdfToPrint}
                warningMessage={warningMessage}
                operativeName={operativeNameText}
                dataReceiver={this.onHandleContractDataReceiver}
                promoCodeEnabled={promoCodeEnabled}
                confirmationLabel={confirmationLabel}
                validatePromotionalCode={validatePromotionalCode}
                confirmationType={confirmationType}
                promotionalCodeAcceptanceChecboxChecked={
                  promotionalCodeAcceptanceChecboxChecked
                }
                promotionalCodeSetDirty={promotionalCodeSetDirty}
                cancelPromotionalCode={cancelPromotionalCode}
                initialStepHasLegalInformation={initialStepHasLegalInformation}
                gdprPlacementId={gdprPlacementId}
                multiOTPMessageCode={multiOTPMessageCode}
                preContractDocuments={this.state.preContractDocuments}
                resetPDFMerge={resetPDFMerge}
                sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                setTermsAndCondsText={setTermsAndCondsText}
                operationProcessId={immContractualPolling.get('operationProcessId')}
                customPrintDocument={customPrintDocument}
                bodyClass={bodyClass}
                printDocumentTranslations={printDocumentTranslations}
                getPrecontractualDocumentURLOrID={getPrecontractualDocumentURLOrID}
                noBorder={ACCOUNT_TYPE_E_LOAN === contractWizard.get('name_contract')}
        />
            {extraComponents}
        </WizardStep>
    );
  }

  buildError(title, message, extraContent, messageInject, customBackButton, genericErrorMessage, phoneNumberClients) {
    const {
      errorBackButtonLabel,
      errorBackButtonLink,
      errorTitle,
      errorMessage,
    } = current_contract;
    const { contractWizard, location } = this.props;
    const goBackButton = customBackButton || {
      label: formatText(errorBackButtonLabel).toUpperCase(),
      url: errorBackButtonLink,
    };
    const titleString = title || errorTitle;
    const messageString = message || errorMessage;
    const extraContentElement = extraContent
      ? contractBuilder[extraContent](contractWizard)
      : null;
    const inject = messageInject
      ? [messageInject]
      : [phoneNumberClients];
    const contractName = contractWizard.get('name_contract');
    let wizardErrorGenericMessage;
    let wizardErrorSubMessage = (
        <div>
            <FormattedText
                value={messageString}
                injectedStrings={inject}
                className="contract-view__wizard-error-sub-message"
        />
        </div>
    );
    if (genericErrorMessage) {
      wizardErrorGenericMessage = (
          <div className="contract-view__wizard-error-sub-message--generic">
              <FormattedText
                  value={genericErrorMessage}
                  injectedStrings={inject}
                  className="contract-view__wizard-error-sub-message"
          />
          </div>
      );
      wizardErrorSubMessage = [wizardErrorSubMessage, wizardErrorGenericMessage];
    }


    let productName, processDetail;
    let processDetailPrefix = ['depositrenewal', 'deposittransfer'].includes(contractName)

    if (['depositnm', 'deposit', 'deposittransfer', 'depositrenewal', CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractName)){
        const depositProduct = contractWizard.get('deposit_product');
        const stringPrefix = contractName === 'depositrenewal' ? 'vencimiento/' : 'contratar ';
        const productDetail = `${stringPrefix}${getDepositProduct(depositProduct.get('type'), depositProduct.get('subtype'), depositProduct.get('standard'))}`;
        processDetail = productDetail;
        productName = contractName !== 'depositrenewal' ?
          getDepositProduct(depositProduct.get('type'), depositProduct.get('subtype'), depositProduct.get('standard')) :
          undefined;
    }

    const tealiumName = current_contract.tealiumName;
    const isAccounts = tealiumName === 'contractingAccount';
    let tealiumData = {
      event_name: 'step_error',
      pageName: `/${tealiumName}/error`,
      sectionFamily: 'banking',
      sectionCategory: 'products',
      sectionName: 'accounts',
      serviceType: 'productContracting',
      interactionType: 'funnel',
      processType: tealiumName,
      processStep: 'error',
      errorCategory: 'requestError',
      errorDescription: formatText(titleString),
      productName,
    };

    if(current_contract.customTagging) {
      if (contractWizard.get('deposit_product') || (isAccounts && contractWizard.get('hiring_data_contract'))) {
        const type = isAccounts ? contractWizard.get('hiring_data_contract').get('type') : contractWizard.get('deposit_product').get('type');
        const subtype = isAccounts ? contractWizard.get('hiring_data_contract').get('subType') : contractWizard.get('deposit_product').get('subtype');
        const standard = isAccounts ?  contractWizard.get('hiring_data_contract').get('standard') :  contractWizard.get('deposit_product').get('standard');
        const isNull = type === null || subtype === null || standard === null;
        const contractType = location.pathname.includes('depositnm') ? 'contratar con incremento' : 'contratar sin incremento';

        tealiumData = {
          ...tealiumData,
          detalleProceso: !isNull || isAccounts ? getMainDepositCategory(type, subtype, standard) : contractType,
          nombreProducto: getDepositProduct(type, subtype, standard),
          productName: getDepositProduct(type, subtype, standard),
        };
      }
    }

    return (
        <WizardError
            errorMessage={formatText(titleString)}
            errorSubMessage={wizardErrorSubMessage}
            mainButton={goBackButton}
            processDetail={processDetail}
            processDetailPrefix={processDetailPrefix}
            productName={productName}
            descriptionError={formatText(titleString)}
            notifyWrapUp={!['depositnm', 'deposit', 'deposittransfer', CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractName)}
            tealium={tealiumData}
            isSecondVersion
      >
            {extraContentElement}
        </WizardError>
    );
  }

  buildFooter() {
    if (!__CONTACT_CENTER__) {
      return (
          <div className="container-fluid grid-view__cross-selling">
              <div className="row">
                  <CommercialAds path="purchase/:contractIndex/:redirect?" type="cross-selling" />
              </div>
          </div>
      );
    }

    return null;
  }

  buildHeaderSubPage() {
    const { breadcrumb, title } = current_contract;
    const immCardDetails = this.props.contractWizard.get('card_details');
    let headerSubPage;

    if (immCardDetails || (!contractBuilder[breadcrumb] && !contractBuilder[title])) {
      const contractBreadcrumb = contractBuilder[breadcrumb]
        ? contractBuilder[breadcrumb](immCardDetails)
        : breadcrumb;
      const contractTitle = contractBuilder[title]
        ? contractBuilder[title](immCardDetails)
        : title;
      const mappingBreadcrumb = contractBreadcrumb.map(item => {
        return {
          text: formatText(item.text),
          url: item.url || '',
        };
      });

      headerSubPage = (
          <OKHeaderSubPage
              breadcrumbConfig={mappingBreadcrumb}
              finalTitle={getFinalTitle(contractTitle)} />
      );
    }

    return headerSubPage;
  }

  buildPrefix(flow, seed, email) {
    return `${flow}${seed}${email}warningMessage`;
  }

  disableFinishButton = (disable) => {
    this.setState({ nextButtonDisabled: disable });
  };

  showAccountLimitModal = () => {
    const { contractWizard } = this.props;
    const hasLimit = contractWizard.getIn(['limitAccount', 'hasLimit']);

    this.setState({ showAccountLimitModalError: hasLimit });
  }

  nextStepActions({ step }) {
    const {
      contractWizard,
      immTermsAndCondsLegalWindow,
      setTermsAndCondsLegalWindow,
      setTermsAndCondsDic,
      immPreContractualPolling,
      sendPreContractualPollingMail
    } = this.props;
    const operationProcessId = immPreContractualPolling.get('operationProcessId');
    const contractName = contractWizard.get('name_contract');
    const visibleStep = contractWizard.get('visibleStep');

    if (contractName === ACCOUNT_TYPE_E_LOAN && visibleStep === 1 && !__CONTACT_CENTER__) {
      return () => contractBuilder[step.on_next_click](this.showAccountLimitModal)
    }

    let productNamePOEKey = null
    const { deposit_product: { context: depositContext, name: depositName } = {} } = this.state;
    const isEAccountFlow = ACCOUNT_TYPE_E_LOAN === contractName

    if (depositContext && depositName) {
      productNamePOEKey = `${depositContext}-${depositName}`;
    }
    if (isEAccountFlow) {
      productNamePOEKey = isEAccountFlow && current_contract.steps[0].title
    }

    if (!immTermsAndCondsLegalWindow.get('success') && !immTermsAndCondsLegalWindow.get('successDic')) {
      const methodsToExecute = () => {
        const isPrecontractualNewView = [...FLOW_WITH_DIC_ACCOUNTS, ...FLOW_WITH_DIC_DEPOSITS].includes(contractName)

        !__CONTACT_CENTER__ && isPrecontractualNewView
          ? setTermsAndCondsDic(current_contract.preContractualAlias)
          : setTermsAndCondsLegalWindow()
        !__CONTACT_CENTER__ && sendPreContractualPollingMail(current_contract, operationProcessId, productNamePOEKey);
      }

      return step.on_next_click && (!immTermsAndCondsLegalWindow.get('success') && !immTermsAndCondsLegalWindow.get('successDic'))
        ? () => contractBuilder[step.on_next_click](methodsToExecute)
        : false;
    }
  }

  buildStep(step) {
    const {
      immProfileFields,
      immCommercialAds,
      immDeposits,
      contractWizard,
      immAccounts,
      immCards,
      immFlagBasedFeatures,
      immHireCardImageSelector,
      immHireCardPinSet,
      immHiringProductInformation,
      immPreContractualPolling,
      immTermsAndCondsLegalWindow,
      closeModal,
      preContractualMail,
      resetCardPin,
      sendPreContractualMail,
      updateConfirmationCheckboxes,
      requestProfile,
      setLegalTextRead,
      location: { search },
      setTermsAndCondsText,
      setTermsAndCondsLegalWindow,
      match,
      getPrecontractualDocumentURLOrID,
      preContractualPollingInitialization,
      immPrecontractualDocumentation,
      setTermsAndCondsDic
    } = this.props;

    const accountId = new URLSearchParams(search).get('accountId');

    const immCardDetails = contractWizard.get('card_details');
    const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');
    const contractName = contractWizard.get('name_contract');
    const visibleStep = contractWizard.get('visibleStep');
    const originCountry = immProfileFields.get('originCountry');

    let hireAccountPassportOrFutureMode;
    let tealiumEventCategory;
    let isSetPinEnabled = false;

    if (this.isCheckingOrPayroll()) {
      const notAllowedPassportPinCountries = immFlagBasedFeatures.get(PIN_ACCOUNT_COUNTRIES_NOT_ALLOWED);
      const pinCountryFlags = !!notAllowedPassportPinCountries ? notAllowedPassportPinCountries : [];

      //Future mode is always active for Passport countries
      hireAccountPassportOrFutureMode = immFlagBasedFeatures.get(PIN_ACCOUNT) || originCountry !== DEFAULT_COUNTRY;

      if (immFlagBasedFeatures.get(PIN_ACCOUNT) && !pinCountryFlags.find(country => country === originCountry)) {
        isSetPinEnabled = true;
      }

      if (contractName === 'checking-account') {
        tealiumEventCategory = PROC_CHECKING_ACCOUNT;
      } else if (contractName === 'payroll-account') {
        tealiumEventCategory = PROC_PAYROLL_ACCOUNT;
      }
    }
    const components = step.components.map((component, index) => {
      return (
          <ContractComponent
              key={index}
              preContractualMail={preContractualMail}
              preContractualMailPolling={immPreContractualPolling}
              precontractualAlias={current_contract.preContractualAlias}
              accountId={accountId}
              component={component}
              localState={this.state}
              contractWizard={contractWizard}
              current_contract={current_contract}
              updateConfirmationCheckboxes={updateConfirmationCheckboxes}
              onLegalTextRead={current_contract.hasPolling && setLegalTextRead}
              sendPreContractualMail={sendPreContractualMail}
              requestProfile={requestProfile}
              immProfileFields={immProfileFields}
              immCommercialAds={immCommercialAds}
              immDeposits={immDeposits}
              immAccounts={immAccounts}
              immCards={immCards}
              immHireCardImageSelector={immHireCardImageSelector}
              immHireCardPinSet={immHireCardPinSet}
              isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
              immHiringProductInformation={immHiringProductInformation}
              flagBasedFeatures={immFlagBasedFeatures}
              gestorCrossEnabled={gestorCrossEnabled}
              nextStep={this.nextStep}
              closeModal={closeModal}
              hireAccountPassportOrFutureMode={hireAccountPassportOrFutureMode}
              tealiumEventCategory={tealiumEventCategory}
              isSetPinEnabled={isSetPinEnabled}
              setTermsAndCondsText={setTermsAndCondsText}
              disableFinishButton={this.disableFinishButton}
              getPrecontractualDocumentURLOrID={getPrecontractualDocumentURLOrID}
              preContractualPollingInitialization={preContractualPollingInitialization}
              match={match}
        />
      );
    });
    const stepFooter = this.buildStepFooter(step);
    const dynamicTitleFunction = contractBuilder[formatText(step.title)];
    const dynamicTitle =
      step.title &&
      dynamicTitleFunction &&
      immCardDetails &&
      dynamicTitleFunction(immCardDetails);

    let title = dynamicTitle || typeof step.title !== 'undefined' ?
        <FormattedText value={`${dynamicTitle || step.title}`} /> :
        <FormattedText value="contractsView-juniorAccountStep3Title" />;
    let subtitle;
    let description;

    if (gestorCrossEnabled && step.position === 'first') {
      title = null;
    }

    if(step.hideTitle){
      title = null
    }

    const cardDetails = contractWizard.get('card_details');
    const showFioc = cardDetails && findElementbyId(cardDetails, 'show_fioc');
    const fiocStep = !__CONTACT_CENTER__ && immFlagBasedFeatures.get(JOIN_HOLDERS) && this.isCheckingOrPayroll() ? contractWizard.get('visibleStep') === 3 : contractWizard.get('visibleStep') === 2;
    if (!(this.isCheckingOrPayroll()
      && fiocStep
      && !showFioc)) {
      subtitle = !!step.subtitle && <FormattedText value={step.subtitle} />;
      description = !!step.description && <FormattedText value={step.description} />;
    }

    const onBackClick = step.on_back_click
      ? contractBuilder[step.on_back_click](this.state.card_details)
      : false;

    const onNextClick = this.nextStepActions({ step })

    const nextButtonDisabled = () => {
      if (step.disableNext && contractBuilder[step.disableNext](contractWizard, immPrecontractualDocumentation)) {
        return step.disableNext && contractBuilder[step.disableNext](contractWizard, immPrecontractualDocumentation);
      }

      if (this.state.nextButtonDisabled) {
        return true;
      }

      return false;
    };

    let details = null;
    if (!!subtitle || !!description) {
      details = (
          <span className="contract-view__wizard__title__details">
              {subtitle}
              {description}
          </span>
      );
    }

    const disableButton = nextButtonDisabled();
    return (
        <WizardStep
            key={step.position}
            position={step.position}
            onBackClick={onBackClick}
            onNextClick={onNextClick}
            nextButtonDisabled={disableButton}
            confirmBackClick={this.handleConfirmBackClick.bind(this, step, immFlagBasedFeatures, resetCardPin, immProfileFields)} // eslint-disable-line
            confirmTitle={step.on_confirm_back_title}
            confirmDescription={step.on_confirm_back_description}
            cancelButton={true}
      >
            <span className="contract-view__wizard__title">
                {title}
                {details}
            </span>

            {components}

            {stepFooter}
        </WizardStep>
    );
  }

  buildStepFooter(step) {
    return <HTMLSafeInjector message={step.footer_text} />;
  }

  buildSteps() {
    const { contractWizard, validateStep, setVisibleStep, setWillCancel, immDeposits, location } = this.props;
    let immSteps = [];
    for (let i = 0; i < current_contract.define_steps + 1; i++) {
      let m = new Map();
      m.set('valid', true);
      if (current_contract.twoStepConfig && i === current_contract.twoStepConfig.onStep) {
        const twoStepValidation = contractWizard.get('twoStepValidation');
        m.set(
          'valid',
          twoStepValidation.length >= 2 &&
          twoStepValidation.every(validation => validation),
        );
      }
      immSteps.push(m);
    }

    immSteps = Immutable.fromJS(immSteps);
    const stepsAmount = current_contract.define_steps + 1;
    const visibleStep = contractWizard.get('visibleStep');
    const wizardClass = 'contract-view__wizard';
    const actions = {
      validateStep,
      setVisibleStep,
      setWillCancel,
      finish: this.onHireContract,
      cancel: this.handleCancel,
    };
    let Steps = [];
    current_contract.steps.forEach(step => {
      Steps.push(this.buildStep(step));
    });
    const initialStep = current_contract.steps[0];
    const tealiumStepsLabels = current_contract.tealiumStepsLabels;
    const tealiumName = current_contract.tealiumName;
    const isAccounts = tealiumName === 'contractingAccount';
    const nameContract = contractWizard.get('name_contract')

    let stepName = ''
    if (CONTRACT_INDEX_DEPOSIT_EXPIRATION === nameContract) {
      stepName = `/${current_contract.tealiumStepsLabels[visibleStep - 1]}`
    }

    let tealium = (tealiumStepsLabels && tealiumStepsLabels.length > 0 && tealiumName) ? {
      event_name: `step`,
      pageName: `/${tealiumName}/step${visibleStep}${stepName}`,
      sectionFamily: 'banking',
      sectionCategory: 'products',
      sectionName: isAccounts ? 'accounts' : 'deposits',
      serviceType: 'productContracting',
      interactionType: 'funnel',
      processType: tealiumName,
      processStep: `step${visibleStep}`,
      processDetail: "",
    } : {};
    let productName = !current_contract.customTagging ? current_contract.title : '';
    if (hasTranslation(productName)) {
      tealium.productName = formatText(productName, [], 'es');
    }

    let tealiumEvents = {
      cancel: { eventName: LINK_CLICK_ACTION_EVENT, eventTag: CANCEL_ACTION_EVENT },
      finish: { eventName: BUTTON_CLICK, eventTag: CONTRACT_BUTTON },
      next: { eventName: BUTTON_CLICK, eventTag: NEXT_ACTION_EVENT },
      previous: { eventName: BUTTON_CLICK, eventTag: PREVIOUS_ACTION_EVENT },
    };

    if(current_contract.customTagging) {
      switch (nameContract) {
        case 'deposittransfer':
        case 'depositrenewal':
          const { events, steps } = contractBuilder[current_contract.customTagging](contractWizard, immDeposits);
          tealiumEvents = events;
          tealium = { ...tealium, ...steps, };
          break;
        default: {
          if (contractWizard.get('deposit_product') || (isAccounts && contractWizard.get('hiring_data_contract'))) {
            const type = isAccounts ? contractWizard.get('hiring_data_contract').get('type') : contractWizard.get('deposit_product').get('type');
            const subtype = isAccounts ? contractWizard.get('hiring_data_contract').get('subType') : contractWizard.get('deposit_product').get('subtype');
            const standard = isAccounts ?  contractWizard.get('hiring_data_contract').get('standard') :  contractWizard.get('deposit_product').get('standard');
            const isNull = type === null || subtype === null || standard === null;
            const contractType = location.pathname.includes('depositnm') ? 'contratar con incremento' : 'contratar sin incremento';
            tealium = {
              ...tealium,
              nombrePagina: isAccounts ? 'cuentas/contratacion' : 'depositos/contratacion',
              detalleProceso: !isNull || isAccounts ? getMainDepositCategory(type, subtype, standard) : contractType,
              nombreProducto: getDepositProduct(type, subtype, standard),
              productName: getDepositProduct(type, subtype, standard),
            };
          }
          break;
        }
      }
    }

    //Add Confirmation Steps
    const initialStepHasLegalInformation = initialStep.components.some(e => e.id_component === 'legal-information');
    Steps.push(this.buildConfirmationStep(initialStepHasLegalInformation));
    return (
        <Wizard
            wizardClass={wizardClass}
            actions={actions}
            immSteps={immSteps}
            stepsAmount={stepsAmount}
            visibleStep={visibleStep}
            tealium={tealium}
            tealiumEvents={tealiumEvents}
            isTaggingSecondVersion={true}
            isCustomTagging={current_contract.customTagging && !isAccounts}
            concractWizadLoad={contractWizard.getIn(['mainDeposits', 'data'])}
      >
            {Steps}
        </Wizard>
    );
  }

    buildSuccessful() {
        const {
            contractWizard,
            history,
            immAccounts,
            immProfileFields,
            immCommercialAds,
            immHireCardImageSelector,
            immFlagBasedFeatures,
            saveProcessSelected,
            immDeposits
        } = this.props;
        const cardDetails = contractWizard.get('card_details');
        const { successStep } = current_contract;
        const {
            accountNumber,
            backButtonText,
            backButtonUrl,
            customInstructions: successStepCustomInstructions,
            collectiveSubtitle,
            depositContract,
            extraMessage,
            instructions,
            savingMoneyExtraMessage,
            seed,
            setSuccessAdditionalInfo,
            setSuccessStepPrefix,
            subTitle
        } = successStep;
        let successSubTitle = subTitle && <FormattedText value={subTitle} />;
        if (immProfileFields.get('isCollective')) {
            successSubTitle = collectiveSubtitle && <FormattedText value={collectiveSubtitle} />
        }

    let extraMessageReminder = extraMessage;
    if (contractWizard.get('juniorAccountHiringInitiationPoint') === JUNIOR_ACCOUNT_HIRING_INITIATION_POINT) {
      extraMessageReminder = savingMoneyExtraMessage;
    }
    const goBackButton = {
      label: formatText(backButtonText),
      url: backButtonUrl,
    };
    const cta_seleccionada = cardDetails.find(x => x.get('id') === 'cta_seleccionada');
    const accountId = cta_seleccionada ? cta_seleccionada.get('value') : null;
    const immAccount = accountId ? immAccounts.get('byId').get(accountId) : null;
    let successPagePrefix;
    let additionalInfo;
    // With this logic we make the Success Step dynamic and the params sent to the component depend
    // on the functions declared in the Lib file of the flow.
    if (current_contract.successStepType && current_contract.successStepType === 'dynamic') {
      successPagePrefix = contractBuilder[setSuccessStepPrefix]
        ? contractBuilder[setSuccessStepPrefix](contractWizard, immProfileFields, seed)
        : successPagePrefix;
      additionalInfo = contractBuilder[setSuccessAdditionalInfo]
        ? contractBuilder[setSuccessAdditionalInfo](contractWizard)
        : additionalInfo;
    }
    const flowPrefix = (successPagePrefix && successPagePrefix.flow) || '';
    const seedPrefix = (successPagePrefix && successPagePrefix.seed) || '';
    const emailPrefix = (successPagePrefix && successPagePrefix.email) || '';
    const renewPrefix = (successPagePrefix && successPagePrefix.renew) || '';
    const successTitle = formatText(successStep[`${flowPrefix}title`]);
    const warningMessage =
      successStep[`${this.buildPrefix(flowPrefix, seedPrefix, emailPrefix)}`];
    const customInstructions = successStepCustomInstructions
      ? contractBuilder[successStepCustomInstructions](history, contractWizard, immFlagBasedFeatures)
      : null;

    let successMessageChildren = null

    if (accountNumber) {
      const newAccountNumber = contractWizard.get('newAccount') || '';

      const formattedNewAccountNumber =
        newAccountNumber.indexOf(' ') === -1
          ? formatIbanString(newAccountNumber)
          : newAccountNumber;

      successMessageChildren = <FormattedText value={accountNumber} injectedStrings={[formattedNewAccountNumber]} />;
    }

    if (depositContract) {
      const newDepositContract = contractWizard.get('newDepositContract') || '';
      successMessageChildren = <FormattedText value={depositContract} injectedStrings={[newDepositContract]} />;
    }

    const details = successStep[`${renewPrefix}${flowPrefix}details`];
    const contractName = contractWizard.get('name_contract');

    let tealiumEventCategory, productName, processDetail, nombrePagina;

        if (contractName === 'checking-account') {
            tealiumEventCategory = PROC_CHECKING_ACCOUNT;
        } else if (contractName === 'payroll-account') {
            tealiumEventCategory = PROC_PAYROLL_ACCOUNT;
        } else if (['depositnm', 'deposit', 'depositrenewal', 'deposittransfer', CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractName)){
            const depositProduct = contractWizard.get('deposit_product');
            const stringPrefix = contractName === 'depositrenewal' ? 'vencimiento/' : 'contratar ';
            const product = getDepositProduct(depositProduct.get('type'), depositProduct.get('subtype'), depositProduct.get('standard'))
            const productDetail = `${stringPrefix}${product}`;
            productName = contractName === 'deposittransfer' ? product : undefined
            processDetail = productDetail;
            nombrePagina = contractName === 'deposittransfer' ? 'depositos/transferencia' : window.utag_data.nombrePagina;
        }

        let processOption={
            value: 'EN163',
            get label() {
                return translateText(`${comboTranslationKey}_${this.value}`)
            },
            availableCountries: availableForAllCountries,
            confidential: false
        }

        let impositionAmount = '';
        const depositId = contractWizard?.get('renewalOrExpiredDepositId');
        if (immDeposits) {
          impositionAmount = immDeposits.getIn(['byId', depositId, 'amount', 'amount']);
        }

        const tealiumName = current_contract.tealiumName;
        const tealiumData = {
          event_name: 'step_success',
          pageName: `/${tealiumName}/success`,
          sectionFamily: 'banking',
          sectionCategory: 'products',
          sectionName: 'accounts',
          serviceType: 'productContracting',
          interactionType: 'funnel',
          processType: tealiumName,
          processStep: 'success',
          detalleProceso: productName,
          amount: impositionAmount,
          productName,
        };

        return (
            <WizardSuccess
                eventTag={!['depositrenewal', 'deposittransfer'].includes(contractName)}
                successMessage={successTitle}
                successSubMessage={successSubTitle}
                mainButton={goBackButton}
                successMessageChildren={successMessageChildren}
                productName={productName}
                processDetail={processDetail}
                notifyWrapUp={!['depositnm', 'deposit','deposittransfer', CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractName)}
                tealium={tealiumData}
                isSecondVersion
            >
                {additionalInfo}
                <ContractSummary
                    immAccount={immAccount}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immHireCardImageSelector={immHireCardImageSelector}
                    immProfileFields={immProfileFields}
                    details={details}
                    wizardState={contractWizard}
                    warningMessage={warningMessage}
                    seed={seed}
                    extraMessage={extraMessageReminder}
                    immCommercialAds={immCommercialAds}
                    instructions={instructions}
                    tealiumEventCategory={tealiumEventCategory}
                    processOption={processOption}
                    saveProcessSelected={saveProcessSelected}
                />
                {customInstructions}
            </WizardSuccess>
        );
    }

  createMarkup(text) {
    return { __html: text };
  }

  handleCancel() {
    if(this.props.contractWizard.get('name_contract') === 'deposittransfer'){
      recordLinkV2({
        categoriaEvento: window.utag_data.nombrePagina,
        accionEvento: "modal salir contratacion deposito",
        etiquetaEvento: "vista"
      })
    }
    const redirectTo = current_contract.onCancelURL || '/myprofile/global';
      this.props.history.push(redirectTo);
  }

  setEmptyBirthdateValueOnCalendar(nextCardDetails) {
    // When user clicks return button, the data should be empty
    nextCardDetails.filter((cardDetail, index) => {
      if (['holder_1_birthdate', 'holder_2_birthdate', 'holder_3_birthdate', 'holder_4_birthdate'].includes(cardDetail.id)) {
        nextCardDetails[index].value = null;
      }
    });

    return nextCardDetails;
  }

  handleConfirmBackClick(step, immFlagBasedFeatures, resetCardPin, immProfileFields) {
    if (contractBuilder[step.on_confirm_back_click]) {
      const { contractWizard, updateCardDetails } = this.props;
      const cardDetails = contractBuilder[step.on_confirm_back_click](contractWizard, immFlagBasedFeatures, resetCardPin, this.props.isNerudaUser, immProfileFields.get('originCountry'));
      let nextCardDetails = cardDetails.toJS();

      if (['checking_account', 'payroll_account'].includes(contractWizard.get('contract_type').toLowerCase())) {
        nextCardDetails = this.setEmptyBirthdateValueOnCalendar(nextCardDetails);
      }

      updateCardDetails(nextCardDetails);
    }
  }

  handleConfirmLeave() {
    if(this.props.contractWizard.get('name_contract') === 'deposittransfer'){
      recordLinkV2({
        categoriaEvento: window.utag_data.nombrePagina,
        accionEvento: "modal salir contratacion deposito",
        etiquetaEvento: "confirmar"
      })
    }
    const { reset, resetPrecontractualMail, resetPrintedIndicators } = this.props;
    const redirectTo = current_contract.onCancelURL || '/myprofile/global';
    reset();
    resetPrecontractualMail();
    resetPrintedIndicators();
      this.props.history.push(redirectTo);
  }

  isReady() {
    const {
      contractWizard,
      immAccounts,
      immContractualPolling,
      immPreContractualPolling,
      immTermsAndCondsLegalWindow,
    } = this.props;
    const validJuniorModal = contractWizard
      .get('card_details')
      .find(map => map.get('id') === 'validationModal');
    const isJuniorModalOpen = validJuniorModal ? validJuniorModal.get('openModal') : false;
    const isFirstStep = contractWizard.get('visibleStep') === 1 && !['deposittransfer', 'depositrenewal'].includes(contractWizard.get('name_contract'));
    const isOnUpgradeOrHirePayrollAccountView = this.isPayroll() && immAccounts.get('hasCheckingAccount') && contractWizard.get('shouldShowUpgradeToPayrollPreStep');

    return (
      (!contractWizard.get('validJunior') && isJuniorModalOpen) ||
      contractWizard.get('submitSuccessful') ||
      contractWizard.get('error') ||
      contractWizard.get('immediateCreditError') ||
      contractWizard.get('creditCardRejected') ||
      immTermsAndCondsLegalWindow.get('error') ||
      immPreContractualPolling.getIn(['init', 'error']) ||
      immPreContractualPolling.getIn(['documents', 'error']) ||
      immContractualPolling.getIn(['init', 'error']) ||
      immContractualPolling.getIn(['documents', 'error']) ||
      this.state.card_details.dontShowPreleaveModal ||
      isOnUpgradeOrHirePayrollAccountView ||
      isFirstStep //first step is information only
    );
  }

  nextStep() {
    const card_details = this.props.contractWizard.get('card_details');
    card_details.update(
      card_details.findIndex(
        item =>
          item.get('id') === 'validationModal' ||
          item.get('id') === 'creditLimitSelection',
      ),
      item => item.set('openModal', false),
    );
    this.props.toNextStep(this.props.contractWizard.get('visibleStep'));
  }

  buildPreLeaveModal() {
    const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
    const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
    const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
    const cancelText = formatText('wizard-redirectConfirmationCancelButton');

    return (
        <PreLeaveModalComponent
            confirmationMessage={confirmationMessage}
            confirmationTitle={confirmationTitle}
            acceptText={acceptText}
            cancelText={cancelText}
            isReady={this.isReady}
            beforeLeaving={this.beforeLeaving}
            onConfirmLeave={this.handleConfirmLeave}
      />
    );
  }

  recordPathTagging() {
    recordPath(
      CONTRATOS_DETAIL_PROCESS,
      PAGE_GENERIC,
      CONVERT_TO_OPEN_PAYROLL_ACCOUNT_TIPO_PROCESS,
      CONVERT_TO_OPEN_PAYROLL_ACCOUNT_PASO_PROCESS,
    );
    this.setState({ isTaggingDone: true });
  }

  redirectToAccounts() {
    this.props.showAccountBlockedErrorModal(false);
      this.props.history.push('/myprofile/accounts');
  }

  getErrorModalText (isAccountELoan, { isBlockedAccount, accountLimit }) {
    let modalTitle = null
    let modalDescription = null

    if (isAccountELoan) {
      if (isBlockedAccount) {
        modalTitle = 'contractsView-accountBlocked_title'
        modalDescription = 'contractsView-accountBlocked_description'
      }
      if (accountLimit) {
        modalTitle = 'contractsView-accountLimit_title'
        modalDescription = 'contractsView-accountLimit_description'
      }
    } else {
      modalTitle = __CONTACT_CENTER__
        ? 'accountBlockedErrorModal-errorTitleCC'
        : 'accountBlockedErrorModal-errorTitle'
      modalDescription = __CONTACT_CENTER__
        ? 'accountBlockedErrorModal-errorDescriptionCC'
        : 'accountBlockedErrorModal-errorDescription'
    }

    return ({
      modalTitle: formatText(modalTitle),
      modalDescription: <FormattedText value={modalDescription} />,
    })
  }

  getPollingDocumentCustomError = ({ customErrorKey, currentContract }) => {
    const customError = currentContract.customErrors[customErrorKey];

    if (customError) {
      return {
        errorTitle: customError.errorTitle,
        errorBody: customError.errorBody,
        customBackButton: {
          label: formatText(customError.backButtonLabel).toUpperCase(),
          url: customError.backButtonLink
        }
      }
    }

    return {
      errorTitle: 'contractsView-contractsView_legalWindowErrorTitle',
      errorBody: 'contractsView-contractsView_legalWindowErrorMessage',
      customBackButton: {
        label: formatText('contractsView-contractsView_legalWindowErrorBackButtonLabel').toUpperCase(),
        url: '/myprofile/accounts',
      }
    }
  }

  render() {
    const {
      addSimpleIntervener,
      clearInterveners,
      contractWizard,
      immAccounts,
      immCommercialAds,
      immContractualPolling,
      immGlobalVariables,
      immHireCardImageSelector,
      immHiringProductBanners,
      immPreContractualPolling,
      immProfileFields,
      immTermsAndCondsLegalWindow,
      immFlagBasedFeatures,
      location,
      match: { params: { contractIndex } },
      updateShouldShowUpgradeToPayrollPreStep,
      history,
      immTermsAndCondsInfo
    } = this.props;
    const { isTaggingDone, showAccountLimitModalError } = this.state;
    const { showHelpBar, title } = current_contract;
    const headerSubPage = this.buildHeaderSubPage();
    let hasAvailableAccounts = true;
    if (__CONTACT_CENTER__) {
      hasAvailableAccounts = ownerFromAccount(immAccounts);
    }
    const showHelpSection = showHelpBar
      ? (<div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
          <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText(title)} hasEntrance={false}/>
      </div>)
      : '';
    const shouldShowUpgradeToPayrollPreStep = immAccounts.get('hasCheckingAccount') &&
      contractWizard.get('shouldShowUpgradeToPayrollPreStep');

    let content;
    let footer;
    let skipPreStep = false;

    if (this.isPayroll()) {
      const payrollQueryParams = location.search && UrlHelper.getQueryParams(location.search.substr(1));
      skipPreStep = payrollQueryParams['skip-check'];
      contractBuilder.payrollAccount_getTranslations((shouldShowUpgradeToPayrollPreStep && !skipPreStep), current_contract);
    }

    const allAccountsInactive = contractWizard.get('hasAllAccountsInactive');

    const blockedAccountsIds = immAccounts.get('blockedAccountsIds');
    const isFetching = immHiringProductBanners.get('isAccountBlockedValidationFetching');

    if (allAccountsInactive && blockedAccountsIds.size == 0) {
      let navigateTo = (contractIndex === 'deposit-eighteen-months') ? 'deposits' : 'accounts';

      content = (<InactiveAccountsError
          navigateToBackButtonText={navigateTo}
          navigateToBackButtonURL={navigateTo}
      />);
    }
    // For all flows that require services to respond before doing anything, set dataIsFetching to true so the loading section is shown
    else if (isFetching || contractWizard.get('dataIsFetching') && !contractWizard.get('intervenersIsFetching') && immAccounts.get('blockedAccountsLoading') && contractWizard.getIn(['mainAccount', 'isFetching'])) {
      content = <LoadingSection />;
    } else if (
      contractWizard.get('error') ||
      contractWizard.get('immediateCreditError') ||
      contractWizard.get('creditCardRejected') ||
      immTermsAndCondsLegalWindow.get('error') ||
      immTermsAndCondsLegalWindow.get('errorDic') ||
      contractWizard.getIn(['fiocStatus', 'error']) ||
      (__CONTACT_CENTER__ || [CONTRACT_INDEX_DEPOSIT_NEW_MONEY, CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY, CONTRACT_INDEX_DEPOSIT_TRANSFER, CONTRACT_INDEX_DEPOSIT_RENEWAL, CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractIndex)) && (immPreContractualPolling.getIn(['init', 'error']) || immPreContractualPolling.getIn(['documents', 'error'])) ||
      (contractWizard.get('visibleStep') === 2 || contractWizard.get('visibleStep') === 3) && (immPreContractualPolling.getIn(['init', 'error']) || immPreContractualPolling.getIn(['documents', 'error']) || immPreContractualPolling.getIn(['documentation', 'error'])) ||
      immContractualPolling.getIn(['init', 'error']) ||
      immContractualPolling.getIn(['documents', 'error']) ||
      immContractualPolling.getIn(['documents', 'error']) ||
      contractWizard.get('visibleStep') === 2 && contractWizard.getIn(['mainDeposits', 'error']) ||
      contractWizard.get('visibleStep') === 1 && ['deposittransfer', CONTRACT_INDEX_DEPOSIT_RENEWAL, ACCOUNT_TYPE_E_LOAN, CONTRACT_INDEX_DEPOSIT_EXPIRATION].includes(contractWizard.get('name_contract')) && (contractWizard.getIn(['mainDeposits', 'error']) || contractWizard.get('precontractualDocumentUrlError')) ||
      contractWizard.get('visibleStep') === 1 && [CONTRACT_INDEX_DEPOSIT_RENEWAL, ACCOUNT_TYPE_E_LOAN, CONTRACT_INDEX_DEPOSIT_EXPIRATION].includes(contractWizard.get('name_contract')) && (contractWizard.getIn(['mainDeposits', 'error']) || contractWizard.get('precontractualDocumentIdError')) || immAccounts.get('blockedAccountsError', false) ||
      contractWizard.get('visibleStep') === 4 && [ACCOUNT_TYPE_E_LOAN].includes(contractWizard.get('name_contract')) && (contractWizard.get('precontractualDocumentUrlError') || contractWizard.get('precontractualDocumentIdError')) ||
      contractWizard.getIn(['mainAccount', 'error']) ||
      immPreContractualPolling.getIn(['documentation', 'acceptingDocumentFailed']) ||
      !!immTermsAndCondsInfo.getIn(['error'])
    ) {
      const immErrorObject = contractWizard.get('error') || null;
      let errorTitle;
      let errorBody;
      let extraContent;
      let genericErrorMessage;
      let injectMessage;
      let customBackButton;

      if (contractWizard.get('immediateCreditError')) {
        errorTitle = 'contractsView-preGrantedCreditErrorTitle';
        errorBody = 'contractsView-preGrantedCreditErrorMsg';
        extraContent = current_contract.errorExtraContent;
      }

      if (contractWizard.get('creditCardRejected')) {
        const { successStep } = current_contract;
        errorTitle = successStep.errorTitle;
        errorBody = successStep.errorBody;
        injectMessage = immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']);
      }

      if (!!immTermsAndCondsInfo.getIn(['error'])) {
        const documentError = this.getPollingDocumentCustomError({
          currentContract: current_contract,
          customErrorKey: immTermsAndCondsInfo.getIn(['error', 'errorObject'])
        })

        errorTitle = documentError.errorTitle;
        errorBody = documentError.errorBody;
        customBackButton = documentError.customBackButton
      }

      if (!!contractWizard.getIn(['fiocStatus', 'error'])) {
        const fiocError = this.getPollingDocumentCustomError({
          currentContract: current_contract,
          customErrorKey: contractWizard.getIn(['fiocStatus', 'error', 'errorObject'])
        })

        errorTitle = fiocError.errorTitle;
        errorBody = fiocError.errorBody;
        customBackButton = fiocError.customBackButton
      }

      if ((immPreContractualPolling.getIn(['init', 'error']) || immPreContractualPolling.getIn(['documents', 'error'])) && !['depositnm', 'deposit', CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractWizard.get('name_contract'))) {
        const documentError = this.getPollingDocumentCustomError({
          currentContract: current_contract,
          customErrorKey: immPreContractualPolling.getIn(['init', 'error', 'errorObject']) || immPreContractualPolling.getIn(['documents', 'error', 'errorObject'])
        })

        errorTitle = documentError.errorTitle;
        errorBody = documentError.errorBody;
        customBackButton = documentError.customBackButton
      }

      if ((immContractualPolling.getIn(['init', 'error']) || immContractualPolling.getIn(['documents', 'error'])) && !['depositnm', 'deposit', CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractWizard.get('name_contract'))) {
        const documentError = this.getPollingDocumentCustomError({
          currentContract: current_contract,
          customErrorKey: immContractualPolling.getIn(['init', 'error', 'errorObject']) || immContractualPolling.getIn(['documents', 'error', 'errorObject'])
        })

        errorTitle = documentError.errorTitle;
        errorBody = documentError.errorBody;
        customBackButton = documentError.customBackButton
      }

      if (immErrorObject && immErrorObject.get && immErrorObject.get('type') === 'custom') {
        const customError = current_contract.customErrors['genericError'];
        const specificCustomError = current_contract.customErrors[immErrorObject.get('errorObject')];
        let backButtonLabel;
        let backButtonLink;
        if (customError) {
          errorTitle = customError.errorTitle;
          genericErrorMessage = customError.errorBody;
          backButtonLabel = customError.backButtonLabel;
          backButtonLink = customError.backButtonLink;
        }
        if (specificCustomError) {
          errorTitle = specificCustomError.errorTitle;
          errorBody = specificCustomError.errorBody;
          backButtonLabel = specificCustomError.backButtonLabel || backButtonLabel;
          backButtonLink = specificCustomError.backButtonLink || backButtonLink;
          extraContent = specificCustomError.contentBuilder;
        }
        injectMessage = immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']);
        customBackButton = {
          label: formatText(backButtonLabel).toUpperCase(),
          url: backButtonLink,
        };
      }

      if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
        errorTitle = 'hireAccount-hireAccount_generalErrorTitle';
        errorBody = 'hireAccount-hireAccount_generalErrorText';
        customBackButton = ({
          label: (
              <FormattedText
                  format="uppercase"
                  value="hireCards-backButtonLabel"
            />
          ),
          url: '/myprofile/cards',
        });
      }

      const errorSection = this.buildError(
        errorTitle,
        errorBody,
        extraContent,
        injectMessage,
        customBackButton,
        genericErrorMessage,
        immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente']),
      );
      content = (
          <div className="col-xs-12 col-md-offset-1 col-md-10">
              {errorSection}
          </div>
      );

      footer = this.buildFooter();
    } else if (contractWizard.get('submitSuccessful')) {
      const successSection = this.buildSuccessful();

      content = (
          <div className="col-xs-12 col-md-offset-1 col-md-10">
              {successSection}
          </div>
      );

      footer = this.buildFooter();
    } else if (shouldShowUpgradeToPayrollPreStep && this.isPayroll() && !skipPreStep) {
      !isTaggingDone && this.recordPathTagging();
      content = (
          <div className="col-xs-12 col-md-offset-1 col-md-10">
              {contractBuilder.payrollAccount_buildUpgradeToPayrollAccountStep(updateShouldShowUpgradeToPayrollPreStep, history)}
          </div>
      );
    } else {
      const wizard = this.buildSteps();

      const isAllowedFiocUpdateAccountHiring = immFlagBasedFeatures.get(FIOC_UPDATE_ACCOUNT_HIRING)
      const isAllowedDNIUpdateAccountHiring = immFlagBasedFeatures.get(DNI_UPDATE_ACCOUNT_HIRING)
      const isFetchedFiocStatus = contractWizard.getIn(['fiocStatus', 'isFetched'])

      let showOutsideFooter = false
      let showOutsideSavingsFooter = false

      if(['deposittransfer', 'depositrenewal', CONTRACT_INDEX_DEPOSIT_EXPIRATION].includes(contractWizard.get('name_contract')) && contractWizard.get('visibleStep') === 1){
        showOutsideFooter = true
      }
      if(['e-account-loan'].includes(contractWizard.get('name_contract')) && contractWizard.get('visibleStep') === 1){
        showOutsideSavingsFooter = true
      }
      content = (
          <div>
              <div className="col-xs-12 col-md-8">
                  {wizard}

                  {showOutsideSavingsFooter && <Step1OutsideSavingsFooter contractWizard={contractWizard} originCountry={immProfileFields.get('originCountry')} />}
                  {showOutsideFooter && <Step1OutsideFooter contractWizard={contractWizard} originCountry={immProfileFields.get('originCountry')} />}
                  {(isFetchedFiocStatus && (isAllowedFiocUpdateAccountHiring || isAllowedDNIUpdateAccountHiring)) && (
                    <FiocUpdateModal
                      fiocStatus={contractWizard.get('fiocStatus')}
                      history={history}
                      contractIndex={contractIndex}
                      closeRedirectURL={current_contract.onCancelURL}
                      isAllowedFeatuteFlags={isAllowedDNIUpdateAccountHiring || isAllowedFiocUpdateAccountHiring}
                      isAllowedDNIUpdateAccountHiring={isAllowedDNIUpdateAccountHiring}
                      isAllowedFiocUpdateAccountHiring={isAllowedFiocUpdateAccountHiring}
                      immFlagBasedFeatures={immFlagBasedFeatures}
                    />
                  )}
              </div>
              <div className="col-xs-12 col-md-4">
                  <div className="row">
                      <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                          <NewCardDetails
                              addSimpleIntervener={addSimpleIntervener}
                              clearInterveners={contractWizard.get('name_contract') !== 'depositrenewal' ? clearInterveners : () => {}}
                              immCommercialAds={immCommercialAds}
                              immHireCardImageSelector={immHireCardImageSelector}
                              immProfileFields={immProfileFields}
                              localState={this.state}
                              showCurrentUser={current_contract.showCurrentUser}
                              wizardState={contractWizard}
                              immFlagBasedFeatures={immFlagBasedFeatures}
                              originCountry={immProfileFields.get('originCountry')}
                />
                      </div>
                      {showHelpSection}
                  </div>
              </div>
          </div>
      );
    }

    const isAccountLoanError = ACCOUNT_TYPE_E_LOAN === contractIndex
    const showErrorModal = immHiringProductBanners.get('showErrorModal') || immAccounts.get('blockedAccountsAll') || showAccountLimitModalError;
    const preLeaveModal = allAccountsInactive || showErrorModal ? null : this.buildPreLeaveModal();

    const { modalTitle, modalDescription } = this.getErrorModalText(isAccountLoanError, {
      isBlockedAccount: immAccounts.get('blockedAccountsAll'),
      accountLimit: showAccountLimitModalError
    })

    let accountBlockedErrorModal;
    if (isAccountLoanError) {
      accountBlockedErrorModal = (
        <ContractErrorModal
          description={modalDescription}
          onSubmit={this.redirectToAccounts}
          showModal={showErrorModal}
          title={modalTitle}
        />
      );
    } else {
      accountBlockedErrorModal = (
        <AccountBlockedErrorModal
          description={modalDescription}
          handleSubmit={this.redirectToAccounts}
          showModal={showErrorModal}
          title={modalTitle}
          hasCloseButton={false}
        />
      );
    }

    return (
        <React.Fragment>
            {accountBlockedErrorModal}
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            {headerSubPage}
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
                {footer}
                {preLeaveModal}
            </div>
        </React.Fragment>
    );
  }
}

ContractView.defaultProps = {
  hideIntervenerControls: false,
};

ContractView.propTypes = {
    addSimpleIntervener: PropTypes.func,
    resetPrintedIndicators: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    getBlockedAccounts: PropTypes.func,
    clearInterveners: PropTypes.func,
    closeModal: PropTypes.func,
    contractualPollingInitialization: PropTypes.func.isRequired,
    contractWizard: PropTypes.object.isRequired,
    fetchPdfToPrint: PropTypes.func.isRequired,
    fiocFormStatusReset: PropTypes.func.isRequired,
    getFiocFormStatus: PropTypes.func.isRequired,
    getMainDeposits: PropTypes.func.isRequired,
    getMainAccount: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    hireNoNewMoneyDeposit: PropTypes.func.isRequired,
    getOpenYoungProfiles: PropTypes.func.isRequired,
    getProfessionCnae: PropTypes.func.isRequired,
    getProfessionCno: PropTypes.func.isRequired,
    handleCancelClick: PropTypes.func,
    handleIntervenerTypeChange: PropTypes.func,
    hideIntervenerControls: PropTypes.bool,
    hireJuniorAccount: PropTypes.func.isRequired,
    hireCardImageSelectorReset: PropTypes.func.isRequired,
    hireContractNewAccount: PropTypes.func.isRequired,
    hireDebitCard: PropTypes.func,
    hireNoNewMoneyDeposits: PropTypes.func,
    hireEAccountLoan: PropTypes.func.isRequired,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    immCommercialAds: PropTypes.object.isRequired,
    immCollectivesNotification: PropTypes.object.isRequired,
    immContractualPolling: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immFiocFormStatus: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardPinSet: PropTypes.object.isRequired,
    immOfficePrintedDocument: PropTypes.object.isRequired,
    immPreContractualPolling: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immConsentsGdpr: PropTypes.object,
    immHiringProductBanners: PropTypes.object,
    immHiringProductInformation: PropTypes.object,
    immMergePDFDocuments: PropTypes.object,
    immTermsAndCondsLegalWindow: PropTypes.object,
    isServiceCalled: PropTypes.func.isRequired,
    isUserAbleToHireDepositThirteenMonths: PropTypes.func,
    loadState: PropTypes.func.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    match: PropTypes.object,
    location: PropTypes.object,
    pollingPDFMerge: PropTypes.func,
    productAds: PropTypes.object,
    preContractualMail: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    pinSetReset: PropTypes.func.isRequired,
    promotionalCodeSetDirty: PropTypes.func,
    requestInterveners: PropTypes.func,
    requestPDFMerge: PropTypes.func,
    requestProfile: PropTypes.func.isRequired,
    requestReferenceStandard: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetJuniorAccountHiringInitiationPoint: PropTypes.func.isRequired,
    setContract: PropTypes.func.isRequired,
    setInProgress: PropTypes.func.isRequired,
    setImpositionAmount: PropTypes.func.isRequired,
    setInterveners: PropTypes.func,
    setPayrollAccountPromoCode: PropTypes.func.isRequired,
    setRenewalAccountBlocked: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    signaturePattern: PropTypes.object.isRequired,
    toggleAgree: PropTypes.func.isRequired,
    toNextStep: PropTypes.func,
    updateCardDetails: PropTypes.func.isRequired,
    updateConfirmationCheckboxes: PropTypes.func.isRequired,
    upgradeToPayrollAccount: PropTypes.func.isRequired,
    updateShouldShowUpgradeToPayrollPreStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    requestDepositHireInformation: PropTypes.func.isRequired,
    requestIntervenersSpecial: PropTypes.func.isRequired,
    hireDepositEighteenMonths: PropTypes.func.isRequired,
    hireDepositThirteenMonths: PropTypes.func.isRequired,
    getPreContractualsDocumentURL: PropTypes.func.isRequired,
    hireNewMoneyDepositMonths: PropTypes.func.isRequired,
    hireMainDepositNoNewMoney: PropTypes.func.isRequired,
    hireDepositRenewal: PropTypes.func.isRequired,
    hireDepositExpired: PropTypes.func.isRequired,
    hireDepositTransfer: PropTypes.func.isRequired,
    validatePromotionalCode: PropTypes.func.isRequired,
    promotionalCodeAcceptanceChecboxChecked: PropTypes.func.isRequired,
    cancelPromotionalCode: PropTypes.func.isRequired,
    resetDocumentsAndAgreeCheckBox: PropTypes.func.isRequired,
    resetProductInfo: PropTypes.func.isRequired,
    immSegmentedLoans: PropTypes.object,
    immSavings: PropTypes.object,
    getProfessionCnaeUncategorized: PropTypes.func.isRequired,
    getProfessionCnaeCategory: PropTypes.func.isRequired,
    getSectorSubcategories: PropTypes.func.isRequired,
    resetPreContractualInfo: PropTypes.func.isRequired,
    getCountries: PropTypes.func.isRequired,
    refreshMainBonifiedNoNewMoneyDepositHireInformation: PropTypes.func.isRequired,
    resetCardPin: PropTypes.func.isRequired,
    resetPdfToPrint: PropTypes.func.isRequired,
    resetPrecontractualDocumentMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    resetTermsAndCondsLegalWindow: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    sendPreContractualPollingMail: PropTypes.func.isRequired,
    setDepositPolled: PropTypes.func.isRequired,
    preContractualPollingInitialization: PropTypes.func.isRequired,
    resetContractualPolling: PropTypes.func.isRequired,
    resetPDFMerge: PropTypes.func.isRequired,
    resetPreContractualPolling: PropTypes.func.isRequired,
    getPreContractualsDocumentId: PropTypes.func.isRequired,
    termsAndCondsLegalWindowSetParams: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    setTermsAndCondsLegalWindow: PropTypes.func.isRequired,
    setTermsAndCondsLegalWindow: PropTypes.func.isRequired,
    showAccountBlockedErrorModal: PropTypes.func,
    setTermsAndCondsTimestamp: PropTypes.func.isRequired,
    updateConditionDocumentConfirmation: PropTypes.func,
    isNerudaUser: PropTypes.bool,
    validateBlockedAccount: PropTypes.func,
    setLegalTextRead: PropTypes.func,
    history: PropTypes.object.isRequired,
    saveProcessSelected: PropTypes.func,
    extraContractData: PropTypes.object.isRequired,
};

module.exports.constructor = ContractView;
module.exports.ContractView = withRouter(connect(
    state => ({
        contractWizard: state.contracts,
        immAccounts: state.accounts,
        immCards: state.cards,
        immCommercialAds: state.commercialAds,
        immConsentsGdpr: state.gdprConsents,
        immContractualPolling: state.contractualPolling,
        immCollectivesNotification: state.collectivesNotification,
        immFiocFormStatus: state.fiocFormStatus,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immHireCardImageSelector: state.hireCardImageSelector,
        immHireCardPinSet: state.hireCardPinSet,
        immHiringProductBanners: state.hiringProductBanners,
        immHiringProductInformation: state.hiringProductInformation,
        immMergePDFDocuments: state.precontractualsMergePdfs,
        immOfficePrintedDocument: state.officePrintedDocument,
        immPrecontractualDocumentation: state.preContractualPolling,
        immProfileFields: state.profile,
        immTermsAndCondsLegalWindow: state.termsAndCondsLegalWindow,
        immTermsAndCondsInfo: state.termsAndCondsInfo,
        immSavings: state.globalPosition.getIn(['savings', 'data']),
        immPreContractualPolling: state.preContractualPolling,
        preContractualMail: state.preContractualMail,
        productAds: state.productAds,
        signaturePattern: state.signaturePattern,
        isNerudaUser: state.profile.get('isNerudaUser'),
    }),
    {
        getFiocStatus: contractsActions.fiocStatus,
        addSimpleIntervener: contractsActions.addSimpleIntervener,
        clearInterveners: contractsActions.clearInterveners,
        cancelPromotionalCode: contractsActions.cancelPromotionalCode,
        closeModal: contractsActions.closeModal,
        contractualPollingInitialization: contractualPollingActions.contractualPollingInitialization,
        fetchPdfToPrint: officePrintedDocumentActions.fetchPdfToPrint,
        fiocFormStatusReset: fiocFormStatusActions.getFiocFormStatusReset,
        getBlockedAccounts: blockedAccountsAction.getBlockedAccounts,
        getCountries: contractsActions.getCountries,
        getDocumentsOkApiById: okApiDocuments.getDocumentsOkApiById,
        getFiocFormStatus: fiocFormStatusActions.getFiocFormStatus,
        getLimitAccount: getLimitAccountActions.getLimitAccount,
        getMainDeposits: getMainDepositsActions.getMainDeposits,
        getMainAccount: getMainAccountActions.getMainAccount,
        getHiringDocuments: contractsActions.getHiringDocuments,
        getOpenYoungProfiles: contractsActions.getOpenYoungProfilesForContract,
        getPrecontractualDocumentURLOrID: contractsActions.getPrecontractualDocumentURLOrID,
        getProfessionCnae: contractsActions.getProfessionCnae,
        getProfessionCnaeCategory: contractsActions.getProfessionCnaeCategory,
        getProfessionCnaeUncategorized: contractsActions.getProfessionCnaeUncategorized,
        getProfessionCno: contractsActions.getProfessionCno,
        getSectorSubcategories: contractsActions.getSectorSubcategories,
        hireCardImageSelectorReset: hireCardImageSelectorActions.reset,
        hireContractNewAccount: contractsActions.hireContractNewAccount,
        hireDepositEighteenMonths: hireDepositEighteenMonths.hireDepositEighteenMonths,
        hireDepositThirteenMonths: hireDepositThirteenMonths.hireDepositThirteenMonths,
        hireMainDepositNoNewMoney: hireMainDepositNoNewMoney.hireMainNoNewMoneyDepositMonths,
        hireDepositRenewal: hireDepositRenewal.hireDepositRenewal,
        hireDepositExpired: hireDepositExpired.hireDepositExpired,
        hireDepositTransfer: hireDepositTransfer.hireMainNoNewMoneyDepositMonths,
        hireNewMoneyDepositMonths: hireNewMoneyDeposits.hireNewMoneyDepositMonths,
        hireNoNewMoneyDeposits: hireNoNewMoneyDeposits.hireNoNewMoneyDeposit,
        hireEAccountLoan: hireEAccountLoanActions.hireEAccountLoan,
        getPreContractualsDocumentURL: contractsActions.getPreContractualsDocumentURL,
        hireJuniorAccount: hireJuniorAccountActions.hireAccount,
        isServiceCalled: contractsActions.isServiceCalled,
        isUserAbleToHireDepositThirteenMonths: hireDepositThirteenMonths.isUserAbleToHireDepositThirteenMonths,
        loadState: contractsActions.loadState,
        onDownloadDocument: contractsActions.onDownloadDocument,
        onPrintDocument: contractsActions.onPrintDocument,
        pinSetReset: hireCardPinSetActions.reset,
        pollingPDFMerge: pdfActions.pollingPDFMerge,
        promotionalCodeAcceptanceChecboxChecked: contractsActions.promotionalCodeAcceptanceChecboxChecked,
        promotionalCodeSetDirty: contractsActions.promotionalCodeSetDirty,
        refreshDepositEighteenHireInformation: hireDepositEighteenMonths.refreshDepositEighteenHireInformation,
        refreshMainNoNewMoneyDepositHireInformation: hireMainDepositNoNewMoney.refreshMainNoNewMoneyDepositHireInformation,
        refreshMainBonifiedNoNewMoneyDepositHireInformation: hireMainDepositNoNewMoney.refreshMainBonifiedNoNewMoneyDepositHireInformation,
        refreshNewMoneyDepositHireInformation: hireNewMoneyDeposits.refreshNewMoneyDepositHireInformation,
        refreshNoNewMoneyDepositHireInformation: hireNoNewMoneyDeposits.refreshNoNewMoneyDepositHireInformation,
        removeIntervener: contractsActions.removeIntervener,
        requestDepositEighteenHireInformation: hireDepositEighteenMonths.requestDepositEighteenHireInformation,
        requestNewMoneyDepositHireInformation: hireNewMoneyDeposits.requestNewMoneyDepositHireInformation,
        requestNoNewMoneyDepositHireInformation: hireNoNewMoneyDeposits.requestNoNewMoneyDepositHireInformation,
        requestInterveners: contractsActions.requestAccountInterveners,
        requestIntervenersSpecial: contractsActions.requestIntervenersSpecial,
        requestPDFMerge: pdfActions.requestPDFMerge,
        requestProfile: profile.requestProfile,
        requestReferenceStandard: contractsActions.requestReferenceStandard,
        reset: contractsActions.reset,
        resetBlockedAccounts: blockedAccountsAction.resetBlockedAccounts,
        resetCardPin: hireCardPinSetActions.reset,
        resetDocumentsAndAgreeCheckBox: contractsActions.resetDocumentsAndAgreeCheckBox,
        resetJuniorAccountHiringInitiationPoint: hireJuniorAccountActions.resetJuniorAccountHiringInitiationPoint,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPreContractualInfo: preContractualInfo.resetPreContractualInfo,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        getPreContractualsDocumentId: contractsActions.getPreContractualsDocumentId,
        resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
        resetProductInfo: hiringProductInformation.resetProductInfo,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        resetTermsAndCondsLegalWindow: termsAndCondsLegalWindowActions.reset,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setDepositPolled: contractsActions.setDepositPolled,
        setImpositionAmount: contractsActions.setImpositionAmount,
        setLegalTextRead: preContractualMailActions.setLegalTextRead,
        setRenewalAccountBlocked: contractsActions.setRenewalAccountBlocked,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        sendPreContractualPollingMail: preContractualPollingActions.sendPreContractualPollingMail,
        preContractualPollingInitialization: preContractualPollingActions.preContractualPollingInitialization,
        resetContractualPolling: contractualPollingActions.resetContractualPolling,
        resetPDFMerge: pdfActions.resetPDFMerge,
        resetPreContractualPolling: preContractualPollingActions.resetPreContractualPolling,
        resetPdfToPrint: officePrintedDocumentActions.resetPdfToPrint,
        setContract: contractsActions.setContract,
        setInProgress: contractsActions.setInProgress,
        setInterveners: contractsActions.setInterveners,
        setPayrollAccountPromoCode: contractsActions.setPayrollAccountPromoCode,
        termsAndCondsLegalWindowSetParams: termsAndCondsLegalWindowActions.termsAndCondsLegalWindowSetParams,
        setTermsAndCondsDic: termsAndCondsLegalWindowActions.setTermsAndCondsDic,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
        setTermsAndCondsLegalWindow: termsAndCondsLegalWindowActions.setTermsAndCondsLegalWindow,
        setVisibleStep: contractsActions.setVisibleStep,
        setWillCancel: contractsActions.setWillCancel,
        showAccountBlockedErrorModal: hiringProductBannersActions.showAccountBlockedErrorModal,
        toggleAgree: contractsActions.toggleAgree,
        toNextStep: contractsActions.toNextStep,
        updateCardDetails: contractsActions.updateCardDetails,
        updateConditionDocumentConfirmation: contractsActions.updateConditionDocumentConfirmation,
        updateConfirmationCheckboxes: contractsActions.updateConfirmationCheckboxes,
        updateShouldShowUpgradeToPayrollPreStep: contractsActions.updateShouldShowUpgradeToPayrollPreStep,
        upgradeToPayrollAccount: contractsActions.upgradeToPayrollAccount,
        validateBlockedAccount: hiringProductBannersActions.validateBlockedAccount,
        validatePromotionalCode: contractsActions.requestValidatePromotionalCode,
        validateStep: contractsActions.validateStep,
        saveProcessSelected: myProfileUploadDocumentationAction.saveProcessSelected,
        getDepositLegalTextFormatteddValue: contractsActions.getDepositLegalTextFormatteddValue,
        depositLegalTextReset: contractsActions.depositLegalTextReset,
        parseFiocData: fiocDocumentation.parseFiocData,
    }
)(withFeatureToggling(ContractView)));
